<template>

  <div class="w-100" id="shippingFormComponent">
    <div
      class="d-flex justify-content-center w-100"
      style="margin-top: 10px"
      v-if="loading">
      <loading />
    </div>
    <div v-else class="d-flex flex-column w-100">

      <fieldset-component texto="Detalles" bold class="mt-1" />
      <div class="d-flex mt-1">
        <div class="container-fluid mt-3">
          <div class="row w-100">
            <div class="col-3 px-4 py-2">

              <div v-if="mode === 'add-from-booking'" class="group w-100">
                <div class="form-group w-100">
                  <label for="exampleInputEmail1">Carrier Booking Number (*)</label>
                  <input
                    type="text"
                    required
                    class="form-control"
                    ref="booking_numberr"
                    :value="form.booking_number"
                    :disabled="true"
                    @change="form.booking_number = $event.target.value; getBookingItineraries();">
                  <small id="emailHelp" class="form-text text-muted">Ingrese Carrier Booking Number.</small>
                </div>
              </div>

              <div v-else class="group w-100">

                <div class="form-group w-100">
                  <label for="exampleInputEmail1">Carrier Booking Number (*)</label>
                  <input
                    type="text"
                    required
                    class="form-control"
                    ref="booking_number"
                    :value="form.booking_number"
                    :disabled="mode === 'view'  || mode === 'to-approve'"
                    @change="form.booking_number = $event.target.value; getBookingItineraries();"
                  >
                  <small id="emailHelp" class="form-text text-muted">Ingrese Carrier Booking Number.</small>
                </div>

              </div>
            </div>
            <div v-if="showButtonRecharge" class="col-1 py-3 mt-4">
              <button
                class="btn btn-sm btn-outline-success"
                @click="resetForm()"
                title="Limpiar Formulario">
                <i class="fas fa-redo"></i>
              </button>
            </div>

            <div v-if="type == 2 || type == 3" class="col-2 ">
              <div class="form-group w-100 px-4 py-2">
                  <label for="exampleInputEmail1">Nro. DUS(*)</label>
                  <input
                    type="text"
                    required
                    class="form-control"
                    ref="dus"
                    :disabled="mode === 'view'  || mode === 'to-approve'"
                    :value="form.dus"
                    @change="form.dus = $event.target.value;"
                  >
                  <small id="emailHelp" class="form-text text-muted">Ingrese Número de DUS.</small>
                </div>
            </div>

          </div>
        </div>

      </div>

      <fieldset-component texto="Detalles Generales" bold class="mt-3" />

      <div class="container-fluid">
        <div class="row">
          <div class="col px-4 py-2">
            Campos marcados con (*) son necesarios para crear el Shipping Instruction.
          </div>
        </div>

      </div>

      <div class="container-fluid mt-3">

        <div class="row w-100">
          <div class="col-4 px-4 py-2">

            <div class="form-group w-100">
              <label for="exampleInputEmail1">Shipper Name (*)</label>
              <input
                class="form-control"
                type="text"
                ref="shipper_name"
                :disabled="mode === 'view'  || mode === 'to-approve'"
                required
                :value="form.shipper_name"
                @change="form.shipper_name = $event.target.value"
              >
              <small id="emailHelp" class="form-text text-muted">Nombre del shipper</small>
            </div>
          </div>

          <div class="col-4 px-4 py-2">
            <div class="form-group">
              <label for="forwarder">Forwarder</label>
              <input
                id="forwarder"
                type="text"
                required
                class="form-control"
                ref="forwarder"
                :disabled="mode === 'view'  || mode === 'to-approve'"
                @change="form.forwarder = $event.target.value"
                :value="form.forwarder"
              >
              <small class="form-text text-muted">Forwarder</small>
            </div>

          </div>

          <div class="col-4 px-4 py-2">
            <div class="form-group">
              <label for="freight_payer_name">Freight Payer Name</label>
              <input type="text" class="form-control" ref="freight_payer_name"
                     :disabled="mode === 'view'  || mode === 'to-approve'" id="freight_payer_name" required
                     :value="form.freight_payer_name" @change="form.freight_payer_name = $event.target.value" />
              <small class="form-text text-muted">Freight Payer Name</small>
            </div>

          </div>
        </div>

      </div>


      <div class="container-fluid mt-3">

        <div class="row w-100">
          <div class="col-4 px-4 py-2">

            <div class="form-group">
              <label for="shipper_address">Shipper Address (*)</label>
              <textarea class="form-control"
                        maxlength="280"
                        required
                        rows="5"
                        id="shipper_address"
                        ref="shipper_address"
                        :disabled="mode === 'view'  || mode === 'to-approve'"
                        :value="form.shipper_address"
                        @keyup="formatoAddress({
                  event: $event,
                  field: 'shipper_address' ,
                  length: 70,
                  lines: 4  ,
                }, true)"
              ></textarea>
              <small class="form-text text-muted">Dirección del shipper</small>
            </div>

          </div>

          <div class="col-4 px-4 py-2">

            <div class="form-group">
              <label for="forwarder_address">Address (Printed on B/L)</label>
              <textarea class="form-control" id="forwarder_address"
                        required
                        rows="5"
                        maxlength="255"
                        ref="forwarder_address"
                        :disabled="mode === 'view'  || mode === 'to-approve'"
                        :value="form.forwarder_address"
                        @blur="formatoAddress({
                  event: $event,
                  field: 'forwarder_address' ,
                  length: 70,
                  lines: 4  ,
                })"
              ></textarea>
              <small class="form-text text-muted">Address (Printed on B/L)</small>
            </div>

          </div>

          <div class="col-4 px-4 py-2">

            <div class="form-group">
              <label for="freight_payer_address">Freight Payer Address</label>
              <textarea
                class="form-control"
                required
                id="freight_payer_address"
                ref="freight_payer_address"
                maxlength="255"
                :disabled="mode === 'view'  || mode === 'to-approve'"
                :value="form.freight_payer_address"
                rows="5"
                @blur="formatoAddress({
                  event: $event,
                  field: 'freight_payer_address' ,
                  length: 70,
                  lines: 4
                } )"
              ></textarea>
              <small class="form-text text-muted">Dirección del pagador de la carga</small>
            </div>

          </div>
        </div>

      </div>

      <div class="container-fluid">
        <div class="row w-100">
          <div class="col-4 px-4 py-2">
            <ui-select
              v-if="consignees.length > 0 && mode !== 'view' && mode !== 'use-template' && mode !== 'edit-template'"
              class="w-100"
              label="Consignees"
              placeholder="Seleccione"
              :options="consignees"
              v-model="consignee"
              :keys="{ value: 'id', label: 'name' }"
              @change="asingneConsignee()"
              has-search
            />
          </div>

          <div class="col-4 px-4 py-2">
            <ui-select
              v-if="notifies.length > 0 && mode !== 'view' && mode !== 'use-template' && mode !== 'edit-template' && mode !== 'to-approve'"
              class="w-100"
              label="Notifies"
              v-model="notify"
              placeholder="Seleccione"
              :options="notifies"
              :keys="{ value: 'id', label: 'name' }"
              @change="asingneNotify()"
              has-search
            />
          </div>
        </div>
      </div>

      <div class="container-fluid mt-3">

        <div class="row w-100">
          <div class="col-4 px-4 py-2">

            <div class="form-group">
              <label for="consignee_name">Consignee Name (*)</label>
              <input
                class="form-control"
                type="text"
                required
                maxlength="70"
                :disabled="mode === 'view'  || mode === 'to-approve'"
                ref="consignee_name"
                id="consignee_name"
                :value="form.consignee_name"
                @change="form.consignee_name = $event.target.value; cutConsigneeAndNotify();">
              <small class="form-text text-muted">Nombre del consignatario</small>
            </div>

          </div>

          <div class="col-4 px-4 py-2">
            <div class="form-group">
              <label for="notify_name">Notify Name (*)</label>
              <input
                type="text"
                required
                ref="notify_name"
                :disabled="mode === 'view'  || mode === 'to-approve'"
                class="form-control"
                maxlength="70" :value="form.notify_name" @change="form.notify_name = $event.target.value; ; cutConsigneeAndNotify();"
              />
              <small class="form-text text-muted">Nombre del notificado</small>
            </div>

          </div>

          <div class="col-4 px-4 py-2">

            <ui-select
              class="w-100 "
              label="Naviera (*)"
              :options="navieras"
              has-search
              :disabled="disabledNavieraId || mode === 'edit' || mode === 'view' || mode === 'to-approve'"
              v-model="form.naviera_id"
              ref="naviera_id"
              @change="applyFormat(); listarNaves(); cutConsigneeAndNotify();"
              :keys="{ value: 'id', label: 'name' }"
              placeholder="Seleccione"
            ></ui-select>
          </div>
        </div>

      </div>

      <div class="container-fluid mt-3">

        <div class="row w-100">

          <div class="col-4 px-4 py-2">

            <div class="form-group">
              <label for="consignee_address">Consignee Address (*)</label>
              <textarea
                class="form-control"
                id="consignee_address"
                required
                maxlength="280"
                :value="form.consignee_address"
                rows="5"
                :disabled="mode === 'view'  || mode === 'to-approve'"
                ref="consignee_address"
                @blur="formatoAddress({
                  event: $event,
                  field: 'consignee_address' ,
                  length: 70,
                  lines: 4
                })"></textarea>
              <small class="form-text text-muted">Dirección del consignatario</small>

            </div>

          </div>

          <div class="col-4 px-4 py-2">

            <div class="form-group">
              <label for="notify_address">Notify Address (*)</label>
              <textarea
                class="form-control"
                id="notify_address"
                required
                maxlength="280"
                :value="form.notify_address"
                :disabled="mode === 'view'  || mode === 'to-approve'"
                rows="5"
                ref="notify_address"
                @blur="formatoAddress({
                  event: $event,
                  field: 'notify_address' ,
                  length: 70,
                  lines: 4
                })"
              ></textarea>
              <small class="form-text text-muted">Dirección del notificado</small>
            </div>
          </div>

          <div class="col-4 px-4 py-2">
            <ui-select
              class="w-100 blRelease"
              label="B/L Release Office (*)"
              placeholder="Seleccione"
              :options="puertos"
              :keys="{ value: 'id', label: 'name' }"
              has-search
              ref="bill_of_release_office"
              :disabled="mode === 'view'  || mode === 'to-approve'"
              v-model="form.bill_of_release_office"
            ></ui-select>
          </div>
        </div>

      </div>


      <fieldset-component texto="Transport" bold class="mt-3" />

      <div class="container-fluid ">

        <div class="row w-100 mt-3">
          <div class="col-4 px-4 py-2">
            <ui-select
              class="w-100 "
              label="Vessel (*)"
              :options="vessels"
              v-model="form.vessel"
              ref="vessel"
              has-search
              :disabled="disabledVessel || mode === 'view' || mode === 'to-approve'"
              @change="listarViajes();"
              :keys="{ value: 'id', label: 'name' }"
              placeholder="Vessel"
            ></ui-select>

          </div>

          <div class="col-4 px-4 py-2">
            <ui-select
              class="w-100 "
              label="Voyage (*)"
              :options="voyages"
              ref="voyage"
              has-search
              v-model="form.voyage"
              :disabled="disabledVoyage || mode === 'view' || mode === 'to-approve'"
              :keys="{ value: 'id', label: 'name' }"
              placeholder="Voyage"
            ></ui-select>

          </div>
        </div>

        <div class="row w-100">
          <div class="col-4 px-4 py-2">
            <ui-select
              class="w-100 mr-5"
              label="Origin (Place of Carrier Receipt) (*)"
              placeholder="Seleccione"
              :disabled="disabledOrigin || mode === 'view' || mode === 'to-approve'"
              v-model="form.port_origin_id"
              ref="port_origin_id"
              :keys="{ value: 'id', label: 'name' }"
              has-search
              :options="puertos"
            ></ui-select>
          </div>

          <div class="col-4 px-4 py-2">
            <ui-select
              class="w-100 mr-5"
              label="Port of Load (*)"
              placeholder="Seleccione"
              ref="port_load_id"
              v-model="form.port_load_id"
              :disabled="disabledLoad || mode === 'view' || mode === 'to-approve'"
              :keys="{ value: 'id', label: 'name' }"
              has-search
              :options="puertos"
            ></ui-select>
          </div>

          <div class="col-4 px-4 py-2">
            <ui-select
              class="w-100"
              label="Move Type (*)"
              placeholder="Seleccione"
              :disabled="disabledMoveType || mode === 'view' || mode === 'to-approve'"
              ref="move_type"
              :keys="{ value: 'id', label: 'name' }"
              v-model="form.move_type"
              :options="movesTypes"
            ></ui-select>
          </div>

        </div>

        <div class="row w-100">

          <div class="col-4 px-4 py-2">
            <ui-select
              class="w-100 mr-5"
              label="Destination (Place of Carrier Delivery) (*)"
              placeholder="Seleccione"
              :disabled="disabledDestination || mode === 'view' || mode === 'to-approve'"
              :keys="{ value: 'id', label: 'name' }"
              has-search
              ref="port_destination_id"
              v-model="form.port_destination_id"
              :options="puertos"
            ></ui-select>
          </div>

          <div class="col-4 px-4 py-2">
            <ui-select
              class="w-100 mr-5"
              label="Port of Discharge (*)"
              placeholder="Seleccione"
              :disabled="disabledDischarge || mode === 'view' || mode === 'to-approve'"
              ref="port_discharge_id"
              v-model="form.port_discharge_id"
              :keys="{ value: 'id', label: 'name' }"
              has-search
              :options="puertos"
            ></ui-select>

          </div>

        </div>

      </div>

      <fieldset-component texto="Particulars" bold class="mt-3" />

      <!-- kiosfelix -->
      <div class="container-fluid">
        <div v-for="(item, index) in form.container_shipping_instructions" :key="index" class="row w-100">
          <div class="col-4 px-4 py-2">
            <div v-if="type != 2" class="d-flex flex-column" >
              <strong class="my-4" style="font-size: 1.4em">Container {{ index + 1 }}</strong>

              <div class="form-group w-100">
                <label :for="'container_number'+ index">Container Number (*)</label>
                <input
                  class="form-control"
                  type="text"
                  required
                  @blur="validarFormatoContainer(index)"
                  :ref="'container_number'+ index"
                  :id="'container_number'+ index"
                  :disabled="mode === 'view'  || mode === 'to-approve'"
                  :value="form.container_shipping_instructions[index].container_number"
                  @change="form.container_shipping_instructions[index].container_number = $event.target.value"
                >
                <small class="form-text text-muted">Container Number</small>
              </div>

              <ui-select
                label="Container Type (*)"
                placeholder="Seleccione"
                :options="contenedores"
                has-search
                :id="'container_id'+ index"
                :disabled="mode === 'view'  || mode === 'to-approve'"
                :keys="{ value: 'id', label: 'code' }"
                v-model="item.container_id"
                @change="validateContainer(index)"
              ></ui-select>

              <div class="d-flex w-100 my-2">


                <div class="form-group w-75 pr-4">
                  <label>Container Net Weight (excluding tare)</label>
                  <input
                    :id="'net_weight_container' + index"
                    class="form-control"
                    type="text"
                    v-mask="weightMask"
                    :disabled="mode === 'view'  || mode === 'to-approve'"
                    v-model="form.container_shipping_instructions[index].container_net_weight"
                    @change="form.container_shipping_instructions[index].container_net_weight = $event.target.value"
                  >
                </div>

                <ui-select
                  class="w-25"
                  style="margin-top: 27px"
                  :options="weight_type"
                  disabled
                  :keys="{ value: 'value', label: 'label' }"
                  v-model="item.container_net_weight_type"
                />
              </div>

              <div class="d-flex w-100 my-2">

                <div class="form-group w-75 pr-4">
                  <label>Container Tare Weight</label>
                  <input
                    class="form-control"
                    type="text"
                    v-mask="weightMask"
                    :disabled="mode === 'view'  || mode === 'to-approve'"
                    v-model="form.container_shipping_instructions[index].container_tare_weight"
                    @change="form.container_shipping_instructions[index].container_tare_weight = $event.target.value"
                  >
                </div>

                <ui-select
                  class="w-25"
                  style="margin-top: 27px"
                  :disabled="mode === 'view'  || mode === 'to-approve'"
                  :options="weight_type"
                  :keys="{ value: 'value', label: 'label' }"
                  v-model="item.container_tare_weight_type"
                />
              </div>

              <div class="d-flex w-100 my-2">

                <div class="form-group w-75 pr-4">
                  <label>Container Gross Volume</label>
                  <input
                    :id="'gross_volume_container' + index"
                    class="form-control"
                    type="number"
                    required
                    :disabled="mode === 'view'  || mode === 'to-approve'"
                    :value="form.container_shipping_instructions[index].container_gross_volume"
                    @change="form.container_shipping_instructions[index].container_gross_volume = $event.target.value"
                  >
                </div>

                <div class="form-group w-25">
                  <label>Cubic Meters</label>
                  <input
                    class="form-control"
                    type="text"
                    required
                    disabled
                    :value="form.container_shipping_instructions[index].container_gross_type"
                    @change="form.container_shipping_instructions[index].container_gross_type = $event.target.value"
                  >
                </div>

              </div>

              <div class="row my-2" :ref="'containerParameters' + index">
                <div class="col-6">

                  <div class="form-group w-100">
                    <label>Container Temperature C°</label>
                    <input
                      class="form-control"
                      type="number"
                      :id = "'container_temperature' + index"
                      :disabled="mode === 'view'  || mode === 'to-approve'"
                      :value="form.container_shipping_instructions[index].container_temperature"
                      @change="form.container_shipping_instructions[index].container_temperature = $event.target.value"
                      >
                      <!-- required -->
                  </div>

                </div>

                <div class="col-6">
                  <div class="form-group w-100">
                    <label>Container Ventilation CBM</label>
                    <input
                      class="form-control"
                      type="number"
                      :id = "'container_ventilation_cbm' + index"
                      :disabled="mode === 'view'  || mode === 'to-approve'"
                      :value="form.container_shipping_instructions[index].container_ventilation"
                      @change="form.container_shipping_instructions[index].container_ventilation = $event.target.value"
                      >
                      <!-- required -->
                  </div>
                </div>
              </div>


              <div class="row mt-3">
                <label style="font-size: 1.4em">Seals</label>
              </div>

              <div class="d-flex w-100">

                <div class="form-group pr-3  w-100">
                  <label>Carrier Seal Number</label>
                  <input
                    class="form-control"
                    type="text"
                    required
                    :disabled="mode === 'view'  || mode === 'to-approve'"
                    :value="form.container_shipping_instructions[index].carrier_seal_number"
                    @change="form.container_shipping_instructions[index].carrier_seal_number = $event.target.value"
                  >
                  <small class="form-text text-muted">Carrier Seal</small>
                </div>

                <div class="form-group  pl-2 w-100">
                  <label>Shipper Seal Number</label>
                  <input
                    class="form-control"
                    type="text"
                    required
                    :disabled="mode === 'view'  || mode === 'to-approve'"
                    :value="form.container_shipping_instructions[index].shipper_seal_number"
                    @change="form.container_shipping_instructions[index].shipper_seal_number = $event.target.value"
                  >
                  <small class="form-text text-muted">Shipper Seal</small>
                </div>

              </div>

              <div class="d-flex">

                <div class="form-group pr-3 w-100">
                  <label>Operator Seal Number</label>
                  <input
                    class="form-control"
                    type="text"
                    required
                    :disabled="mode === 'view'  || mode === 'to-approve'"
                    :value="form.container_shipping_instructions[index].terminal_operator_seal_number"
                    @change="form.container_shipping_instructions[index].terminal_operator_seal_number = $event.target.value"
                  >
                  <small class="form-text text-muted"> Terminal Operator Seal</small>
                </div>

                <div class="form-group pl-2 w-100">
                  <label>Veterinary Seal Number</label>
                  <input
                    class="form-control"
                    type="text"
                    required
                    :disabled="mode === 'view'  || mode === 'to-approve'"
                    :value="form.container_shipping_instructions[index].veterinary_seal_number"
                    @change="form.container_shipping_instructions[index].veterinary_seal_number = $event.target.value"
                  >
                  <small class="form-text text-muted"> Veterinary Seal</small>
                </div>

              </div>

              <div class="row w-100 ">
                <div class="col-6">
                  <div class="form-group  w-100">
                    <label>Customs Seal Number</label>
                    <input
                      class="form-control"
                      type="text"
                      required
                      :disabled="mode === 'view'  || mode === 'to-approve'"
                      :value="form.container_shipping_instructions[index].customs_seal_number"
                      @change="form.container_shipping_instructions[index].customs_seal_number = $event.target.value"
                    >
                    <small class="form-text text-muted"> Customs Seal </small>
                  </div>
                </div>

              </div>


              <div class="d-flex flex-column w-100 mt-4"></div>
            </div>
          </div>
          <div class="col-8 px-4 py-2">
            <div
              class="d-flex mb-4"
              v-for="(cargo, indexCargo) in item.shipping_instructions_container_cargos"
              :key="indexCargo"
              style="border-bottom: dashed 1.2pt #9e9d9d"
            >

              <div class="d-flex w-100 flex-column">
                <strong class="my-3" style="font-size: 1.4em">Cargo {{ indexCargo + 1 }}</strong>

                <div class="row w-100 mt-3 ">
                  <div class="col-6">

                    <div class="form-group">
                      <label>Package Count (*)</label>
                      <input
                        class="form-control"
                        type="number"
                        required
                        :disabled="mode === 'view'  || mode === 'to-approve'"
                        :id="'package_count' + index + indexCargo"
                        :value="form.container_shipping_instructions[index].shipping_instructions_container_cargos[indexCargo].package_count"
                        @change="form.container_shipping_instructions[index].shipping_instructions_container_cargos[indexCargo].package_count = $event.target.value; calcularTotalNumbeOfPackages();"
                      >
                      <small class="form-text text-muted"> Count packages </small>
                    </div>

                  </div>

                  <div class="col-6">

                    <ui-select
                      v-if="type == 2"
                      placeholder="Seleccione"
                      has-search
                      :options="palletsList"
                      label="Type (*)"
                      :disabled="mode === 'view'  || mode === 'to-approve' "
                      :id="'pallet_id' + index + indexCargo"
                      :keys="{ value: 'id', label: 'name' }"
                      v-model="cargo.pallet_id"
                    />
                    <ui-select
                      v-else
                      placeholder="Seleccione"
                      has-search
                      :options="listarPackingTypes"
                      label="Type (Outermost) (*)"
                      :disabled="mode === 'view'  || mode === 'to-approve' "
                      :id="'package_type_id' + index + indexCargo"
                      :keys="{ value: 'id', label: 'name' }"
                      v-model="cargo.package_type_id"
                    />
                  </div>

                </div>


                <div class="row  w-100">
                  <div class="col-6">

                    <div class="form-group">
                      <label>HS Code</label>
                      <input
                        class="form-control"
                        type="number"
                        required
                        :disabled="mode === 'view'  || mode === 'to-approve'"
                        :value="form.container_shipping_instructions[index].shipping_instructions_container_cargos[indexCargo].hs_code"
                        @change="form.container_shipping_instructions[index].shipping_instructions_container_cargos[indexCargo].hs_code = $event.target.value;"
                      >
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <div class="form-group w-100">
                      <label>Cargo Description (*) </label>
                      <textarea
                        class="form-control"
                        required
                        :disabled="mode === 'view'  || mode === 'to-approve'"
                        :id="'description' + index + indexCargo"
                        :value="form.container_shipping_instructions[index].shipping_instructions_container_cargos[indexCargo].description"
                        @change="form.container_shipping_instructions[index].shipping_instructions_container_cargos[indexCargo].description = $event.target.value"
                      >
                      </textarea>
                      <small class="form-text text-muted">Enter Cargo Description</small>
                    </div>

                  </div>
                </div>


                <div class="row mb-4">
                  <div class="col-12">

                    <div class="form-group w-100">
                      <label> Marks and Numbers </label>
                      <textarea
                        class="form-control"
                        required
                        maxlength="350"
                        :disabled="mode === 'view'  || mode === 'to-approve'"
                        :value="form.container_shipping_instructions[index].shipping_instructions_container_cargos[indexCargo].marks_and_numbers"
                        @change="form.container_shipping_instructions[index].shipping_instructions_container_cargos[indexCargo].marks_and_numbers = $event.target.value"
                      >
                      </textarea>
                      <small class="form-text text-muted">Enter Marks and Numbers</small>
                    </div>
                  </div>
                </div>
              </div>

              <div class="d-flex w-100 flex-column px-4">

                <div class="row my-3">
                  <div class="col-12">
                    <strong style="font-size: 1.4em" class="">Cargo Gross Weight & Volume</strong>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-9 px-3">

                    <div class="form-group">
                      <label> Cargo Gross Weight (Cargo + Packaging) (*) </label>
                      <input
                        :id="'gross_weight' + index + indexCargo"
                        class="form-control"
                        type="text"
                        v-mask="weightMask"
                        :disabled="mode === 'view'  || mode === 'to-approve'"
                        v-model="form.container_shipping_instructions[index].shipping_instructions_container_cargos[indexCargo].gross_weight"
                        @keyup="form.container_shipping_instructions[index].shipping_instructions_container_cargos[indexCargo].gross_weight = $event.target.value; calcularTotalShipmentWeight(); sumarCargoGrossWeightPorContenedor(index, indexCargo);"
                      >
                      <small class="form-text text-muted"> Cargo Gross Weight </small>
                    </div>

                  </div>
                  <div class="col-3">
                    <ui-select
                      class="w-100"
                      style="margin-top: 27px"
                      :options="weight_type"
                      disabled
                      :keys="{ value: 'value', label: 'label' }"
                      v-model="cargo.gross_weight_type"
                    />
                  </div>
                </div>

                <div class="row ">
                  <div class="col-9 px-3">

                    <div class="form-group">
                      <label> Cargo Gross Volume (Cargo + Packaging) </label>
                      <input
                        class="form-control"
                        type="text"
                        :id="'gross_volume' + index + indexCargo"
                        required
                        v-mask="weightMask"
                        :disabled="mode === 'view'  || mode === 'to-approve'"
                        :value="form.container_shipping_instructions[index].shipping_instructions_container_cargos[indexCargo].gross_volume"
                        @keyup="form.container_shipping_instructions[index].shipping_instructions_container_cargos[indexCargo].gross_volume = $event.target.value; calcularTotalShipmentWeight(); sumarCargoGrossVolumePorContenedor(index, indexCargo)">
                    </div>

                  </div>

                  <div class="col-3">
                    <input
                      class="form-control w-100"
                      type="text"
                      style="margin-top: 29px;"
                      disabled
                      value="CBM">
                  </div>
                </div>

                <div class="d-flex px-2" v-if="mode !== 'view' && mode !== 'to-approve'">
                  <label style="font-size: 1.1em"> Cargo Actions: </label>
                </div>

                <div
                  class="d-flex w-100 mt-1 px-2"
                  style="justify-content: space-between"
                  v-if="mode !== 'view' && mode !== 'to-approve'">

                  <button
                    class="btn btn-sm btn-outline-success"
                    @click="anadirCargo(index)">
                    <i class="fa fa-plus"></i> Añadir cargo a este container
                  </button>

                  <button
                    class="btn btn-sm btn-outline-danger"
                    :disabled="indexCargo === 0"
                    @click="eliminarCargo(index, indexCargo)">
                    <i class="fa fa-minus"></i> Eliminar este cargo
                  </button>

                </div>
                <div class="row mt-4 px-2" v-if="mode !== 'view' && mode !== 'to-approve'">
                  <div class="col-12">
                    <div v-if="type != 2" class="d-flex w-100">
                      <label style="font-size: 1.1em">Container Actions: </label>
                    </div>
                  </div>
                </div>
                <div class="row mt-2 px-2" v-if="mode !== 'view' && mode !== 'to-approve'">
                  <div class="col-12" v-if="type != 2">
                    <div class="d-flex w-100 h-100" style="justify-content: space-between">

                      <button
                        v-if="mode !== 'view'  &&  mode !== 'to-approve' "
                        class="btn btn-sm btn-outline-success w-25"
                        @click="anadirContainer(index)">
                        <i class="fa fa-plus"></i> Añadir
                      </button>

                      <button
                        v-if="mode !== 'view'  &&  mode !== 'to-approve' "
                        class="btn btn-sm btn-outline-primary w-25"
                        @click="duplicarContainer(index)">
                        <i class="fa fa-copy"></i> Duplicar
                      </button>

                      <button
                        v-if="mode !== 'view' && mode !== 'to-approve'"
                        class="btn btn-sm btn-outline-danger w-25"
                        :id="'btnContainerDelete'+ index"
                        :disabled="index === 0"
                        @click="eliminarContainer(index)">
                        <i class="fa fa-minus"></i> Eliminar
                      </button>

                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>


      <fieldset-component texto="Control Totals" bold class="mt-3 mb-4" />
      <div class="container-fluid">
        <div class="row w-100">
          <div class="col-3 px-4 py-2">

            <ui-textbox
              class="w-100"
              label="Total Number of Containers"
              v-model="totalNumberOfContainers"
              disabled
            ></ui-textbox>
          </div>

          <div class="col-3 px-4 py-2">
            <ui-textbox
              class="w-100 "
              label="Total Number of Packages"
              v-model="totalNumbeOfPackages"
              disabled
            ></ui-textbox>
          </div>

          <div class="col-3 px-4 py-2">

            <ui-textbox
              class="w-100 "
              label="Total Shipment Weight"
              v-model="totalShipmentWeight"
              disabled
            ></ui-textbox>
          </div>
        </div>
      </div>
 
      <div class="container-fluid" v-if="type === 1 && tariffBase.length > 0 && this.usuarioActual.id_country !== 8">

        <fieldset-component texto="Tariff Base" bold class="mt-3" />
        
        <table class="table ">
            <tr>
              <th> Nombre </th>
              <th> Valor </th>
              <th> Moneda </th>
              <th> Unidad </th>
              <th> Total </th>
              <th> Freight Terms (*) </th>
              <th> Payer (*) </th>
              <th> Payment Location </th>
            </tr>  
            <tr v-for="(tb, index) in tariffBase" :key="index">

              <td style="padding: 0px;">
                <input
                    type="text"
                    required
                    :value="tb.name"
                    :disabled="true"
                  >
              </td>

              <td style="padding: 0px;">
                <input
                    type="text"
                    required
                    :value="tb.public_value"
                    :disabled="true"
                  >
              </td>
              <td style="padding: 0px;">
                <input
                    type="text"
                    required
                    :value="tb.currency"
                    :disabled="true"
                  >
              </td>
              <td style="padding: 0px;">
                <input
                    type="text"
                    required
                    :value="tb.unit"
                    :disabled="true"
                  >
              </td>
              <td style="padding: 0px;">
                <input
                    type="text"
                    required
                    :value=" tb.public_value * totalNumberOfContainers"
                    :disabled="true"
                  >
              </td>
              
              <td style="padding: 0px;">
                <ui-select
                style="padding:0px"
                  class="w-100 pr-4"
                  :keys="{ value: 'id', label: 'name' }"
                  placeholder="Seleccione"
                  v-model="tb.freight_term"
                  has-search
                  :disabled="mode === 'view'  || mode === 'to-approve'"
                  :id="'freight_term' + index"
                  :options="freightTerm"
                ></ui-select>
              </td>

              <td style="padding: 0px;">
                <ui-select
                  style="padding:0px"
                  class="w-100 pr-4"
                  :keys="{ value: 'id', label: 'name' }"
                  placeholder="Seleccione"
                  v-model="tb.payer"
                  has-search
                  :disabled="mode === 'view'  || mode === 'to-approve'"
                  :id="'payer' + index"
                  :options="payers"
                />
              </td>

              <td style="padding: 0px;">
                <ui-select
                  style="padding:0px"
                  class="w-100"
                  :keys="{ value: 'id', label: 'name' }"
                  placeholder="Seleccione"
                  v-model="tb.payment_location"
                  has-search
                  :disabled="mode === 'view'  || mode === 'to-approve'"
                  :options="puertos"
                ></ui-select>
              </td>
              
            </tr>
          </table> 
      </div>

      
      <div class="container-fluid" v-if="type === 1 && recharges.length > 0 && this.usuarioActual.id_country !== 8">

        <fieldset-component texto="Recharges" bold class="mt-3" />

          <table class="table ">
            <tr>
              <th> Nombre </th>
              <th> Valor </th>
              <th> Moneda </th>
              <th> Unidad </th>
              <th> Total </th>
              <th> Freight Terms (*) </th>
              <th> Payer (*) </th>
              <th> Payment Location </th>
            </tr>  

            <tr v-for="(item, index) in recharges" :key="index">

              <td style="padding: 0px;">
                <input
                    type="text"
                    required
                    :value="item.name"
                    :disabled="true"
                  >
              </td>

              <td style="padding: 0px;">
                <input
                    type="text"
                    required
                    :value="item.public_value"
                    :disabled="true"
                  >
              </td>

              <td style="padding: 0px;">
                <input
                    type="text"
                    required
                    :value="item.currency"
                    :disabled="true"
                  >
              </td>
              
              <td style="padding: 0px;">
                <input
                    type="text"
                    required
                    :value="item.unit"
                    :disabled="true"
                  >
              </td>

              <td style="padding: 0px;">
                <input
                  type="text"
                  required
                  v-model = "item.total"
                  :disabled="true"
                  >

              </td>
              
              <td style="padding: 0px;">
                <ui-select
                style="padding:0px"
                  class="w-100 pr-4"
                  :keys="{ value: 'id', label: 'name' }"
                  placeholder="Seleccione"
                  v-model="item.freight_term"
                  has-search
                  :disabled="mode === 'view'  || mode === 'to-approve'"
                  :id="'freight_term' + index"
                  :options="freightTerm"
                ></ui-select>
              </td>

              <td style="padding: 0px;">
                <ui-select
                  style="padding:0px"
                  class="w-100 pr-4"
                  :keys="{ value: 'id', label: 'name' }"
                  placeholder="Seleccione"
                  v-model="item.payer"
                  has-search
                  :disabled="mode === 'view'  || mode === 'to-approve'"
                  :id="'payer' + index"
                  :options="payers"
                />
              </td>

              <td style="padding: 0px;">
                <ui-select
                  style="padding:0px"
                  class="w-100"
                  :keys="{ value: 'id', label: 'name' }"
                  placeholder="Seleccione"
                  v-model="item.payment_location"
                  has-search
                  :disabled="mode === 'view'  || mode === 'to-approve'"
                  :options="puertos"
                ></ui-select>
              </td>

            </tr>
          </table> 
      </div>

      <div class="container-fluid" v-if="(tariffBase.length === 0 && recharges.length === 0) || this.usuarioActual.id_country === 8">
        <fieldset-component texto="Freight Charges" bold class="mt-3" />

        <div class="row w-100 mt-2">
          <div class="col-10">
            <em> (*) Para cargos individuales debe existir al menos un tipo de carga Basic Freight.</em>
            <br />
            <em>(*) Solo está permitida una ocurrencia de cada tipo de carga.</em>
          </div>
          <div class="col-2">
            <Button
              :size="17"
              :width="35"
              color="#2da44e"
              colorText="#ffffff"
              icon="fas fa-plus"
              tooltip="Añadir Freight"
              round
              traslate
              v-if="!showAllFreightCharges && (mode !== 'view' ||  mode !== 'to-approve')"
              :disabled="mode === 'view'  || mode === 'to-approve'"
              @click.native="anadirFreightCharges();"
            />
          </div>
        </div>
        <div class="row w-100">
          <div class="col-8 px-4 py-2">
            <ui-radio-group
              class="w-50 mr-2 mt-4"
              name="chargesOptions"
              @change="changeStateFreight()"
              :options="chargesOptions"
              v-model="chargeOption"
              :disabled="mode === 'view'  || mode === 'to-approve'"
              vertical
            ></ui-radio-group>
          </div>

        </div>

        <div v-for="(charge, index) in form.freight_charges" class="row w-100" :key="index">
          <div class="col-3 px-4 py-2" v-if="!showAllFreightCharges">
            <ui-select
              class="w-100"
              label="Charge Type (*)"
              :keys="{ value: 'id', label: 'name' }"
              placeholder="Seleccione"
              v-model="charge.charge_type_id"
              :id="'charge_type_id' + index"
              :options="charge.options"
              :disabled="(( !showAllFreightCharges ) && ( index === 0 )) || mode === 'view'"
            ></ui-select>
          </div>

          <div class="col-3 px-4 py-2">
            <ui-select
              class="w-100"
              label="Freight Term (*)"
              :keys="{ value: 'id', label: 'name' }"
              placeholder="Seleccione"
              v-model="charge.freight_term"
              :disabled="mode === 'view'  || mode === 'to-approve'"
              :id="'freight_term' + index"
              :options="freightTerm"
            ></ui-select>
          </div>
          <div class="col-2 px-4 py-2">
            <ui-select
              class="w-100"
              label="Payer (*)"
              :keys="{ value: 'id', label: 'name' }"
              placeholder="Seleccione"
              v-model="charge.payer"
              has-search
              :id="'payer' + index"
              :disabled="mode === 'view'  || mode === 'to-approve'"
              :options="payers"
            ></ui-select>
     
          </div>

          <div class="col-3 px-4 py-2">
            <ui-select
              class="w-100 mr-3"
              label="Payment Location"
              placeholder="Seleccione"
              has-search
              :disabled="mode === 'view'  || mode === 'to-approve'"
              v-model="charge.payment_location_id"
              :keys="{ value: 'id', label: 'name' }"
              :options="puertos"
            ></ui-select>
          </div>

          <div class="col-1">

            <Button
              :size="17"
              :width="35"
              color="#AB0000"
              colorText="#AB0000"
              icon="fas fa-minus"
              tooltip="Quitar Freight"
              round
              class="mt-4"
              traslate
              v-if="!showAllFreightCharges || mode === 'view' ||  mode === 'to-approve'"
              :inactive="index === 0"
              @click.native="index !== 0 && deleteFreightCharges( index );"
            />
          </div>
        </div>

      </div>

      <fieldset-component
        texto="B/L Print Instructions (Provided to the Carrier, not printed on Bill of Landings)"
        bold
        class="mt-3 mb-4"
      />
      <div class="container-fluid">
        <div class="row w-100">
          <div class="col-3 px-4 py-2">
            <strong>B/L Type</strong>
            <ui-radio-group
              class="w-100 mr-2 mt-2 blOptionsRadio"
              name="group1"
              vertical
              :options="blType"
              :disabled="mode === 'view'  || mode === 'to-approve'"
              v-model.lazy="form.bl_type"
            ></ui-radio-group>
          </div>

          <div class="col-3 px-4 py-2">

            <div class="form-group w-100">
              <label> Freighted </label>
              <input
                class="form-control"
                type="number"
                required
                :disabled="form.bl_type === 'standalone_house_bill' || mode === 'view' ||  mode === 'to-approve'"
                :value="form.freighted_copies"
                @change="form.freighted_copies = $event.target.value;"
              >
              <small class="form-text text-muted">Enter # Copies</small>
            </div>

            <div class="form-group w-100">
              <label> Non-Negotiable Freighted </label>
              <input
                class="form-control"
                type="number"
                required
                :disabled="form.bl_type === 'standalone_house_bill' || form.bl_type === 'seaway_express' || mode === 'view' ||  mode === 'to-approve'"
                :value="form.non_negotiable_freighted_copies"
                @change="form.non_negotiable_freighted_copies = $event.target.value;"
              >
              <small class="form-text text-muted">Enter # Copies </small>
            </div>

            <div class="form-group w-100">
              <label> House Bill Number</label>
              <input
                class="form-control"
                type="number"
                required
                :disabled="form.bl_type === 'original' || form.bl_type === 'seaway_express' || mode === 'view' ||  mode === 'to-approve'"
                :value="form.house_bill_number"
                @change="form.house_bill_number = $event.target.value;"
              >
              <small class="form-text text-muted">Enter Number </small>
            </div>

          </div>
          <div class="col-3 px-4 py-2">

            <div class="form-group w-100">
              <label> Unfreighted </label>
              <input
                class="form-control"
                type="number"
                required
                :disabled="form.bl_type === 'standalone_house_bill' || mode === 'view' ||  mode === 'to-approve'"
                :value="form.unfreighted_copies"
                @change="form.unfreighted_copies = $event.target.value;"
              >
              <small class="form-text text-muted">Enter # Copies </small>
            </div>

            <div class="form-group w-100">
              <label> Non-Negotiable Unfreighted </label>
              <input
                class="form-control"
                type="number"
                required
                :disabled="form.bl_type === 'standalone_house_bill' || form.bl_type === 'seaway_express' || mode === 'view' ||  mode === 'to-approve'"
                :value="form.non_negotiable_unfreighted_copies"
                @change="form.non_negotiable_unfreighted_copies = $event.target.value;"
              >
              <small class="form-text text-muted">Enter # Copies </small>
            </div>

          </div>
          <div class="col-3 px-4 py-2">

            <div class="form-group ">
              <label> B/L Comments </label>
              <textarea
                required
                :rows="6"
                class="form-control"
                :value="form.bl_comments"
                :disabled="mode === 'view'  || mode === 'to-approve' "
                @change="form.bl_comments = $event.target.value;"
              >
              </textarea>
              <small class="form-text text-muted"> Enter Comments </small>
            </div>

          </div>
        </div>
      </div>


      <div class="card"
           v-if="(mode === 'to-approve' && !visibleModalRejectShipping) && (idRol === 1 || idRol === 2 || idRol === 5 || idRol === 9999)"
           style="position: fixed; width: 18rem; padding: 9px; left: 85%; transform: translateX(-85%); bottom: 12px; z-index: 999; align-content: center; justify-content: center">
        <div class="card-body">
          <div class="col-lg-12">
            <p class="text-center fw-semibold mb-3">Seleccione una opción</p>
            <div class="row">
              <div class="col-md-6 text-start">
                <button class="btn btn-sm btn-success" @click="approve()">
                  <i class="far fa-thumbs-up"></i> Aceptar
                </button>
              </div>
              <div class="col-md-6 text-end">
                <button class="btn btn-sm btn-danger" @click="reject()">
                  <i class="far fa-thumbs-down"></i> Rechazar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <hr />
      <div class="container-fluid mt-5">
        <div class="row w-100">

          <div class="col-2">

            <button class="btn-md btn btn-outline-danger mt-3" @click="closeModal()">
              Cerrar
            </button>

          </div>

          <div class="col-2"></div>

          <div class="col-2">

            <div class="form-group " style="margin-top: -13px;">
              <label>SI Name</label>
              <input
                class="form-control"
                type="text"
                required
                maxlength="70"
                ref="template_name"
                :disabled="mode === 'view' || mode === 'to-approve'"
                :value="form.template_name"
                @change="form.template_name = $event.target.value"
              />
              <small class="form-text text-muted">5 caracteres mínimo</small>
            </div>

          </div>

          <div class="col-2">

            <button
              v-if="mode !== 'view' && mode !== 'use-template' && mode !== 'to-approve'"
              class="btn  btn-outline-primary btn-md mt-3"
              @click="mode === 'edit-template' ? editTemplate() : saveTemplate()"
              :disabled="btnDisabled">
              <i class="fa fa-download"></i> Save Template
            </button>

          </div>


          <div class="col-2">

            <button
              v-if="mode === '' && mode !== 'view'"
              class="btn btn-outline-success float-right btn-md mt-3"
              :disabled="btnDisabled"
              @click="saveAndSend(false)">
              <i class="fa fa-check"></i> Crear
            </button>

            <button
              v-if="mode === 'add-from-booking'"
              class="btn btn-outline-success float-right btn-md mt-3"
              :disabled="btnDisabled"
              @click="saveAndSendFromBooking(false)">
              <i class="fa fa-check"></i> Crear
            </button>

            <button
              v-if="mode === 'use-template'"
              class="btn btn-outline-success float-right btn-md mt-3"
              @click="saveAndSendTemplate(false)"
              :disabled="btnUseTemplate">
              <i class="fa fa-check"></i> Crear
            </button>

            <button
              v-if="mode === 'edit'  && mode !== 'view'"
              class="btn btn-outline-success float-right btn-md mt-3"
              :disabled="btnDisabled"
              @click="editAndSend(false)">
              <i class="fa fa-check"></i> Editar
            </button>

            <button
              v-if="mode === 'view' "
              class="btn btn-outline-success float-right btn-md mt-3"
              :disabled="btnDisabled"
              @click="downloadPdf()"
              ref="btnDownloadPdf">
              <i class="fa fa-paper-plane"></i> {{ textBtnDownloadPdf }}
            </button>

          </div>

          <div class="col-2">

            <button
              v-if="mode === '' && mode !== 'view' && type == 1"
              class="btn btn-outline-success float-right btn-md mt-3"
              :disabled="btnDisabled"
              @click="saveAndSend(true)">
              <i class="fa fa-paper-plane"></i> Crear y Enviar
            </button>

            <span v-if="(type != 3 && type != 2) ">
              <button
                v-if="mode === 'edit' && mode !== 'view'"
                class="btn btn-outline-success float-right btn-md mt-3"
                :disabled="btnDisabled"
                @click="editAndSend()">
                <i class="fa fa-paper-plane"></i> Editar y Enviar
              </button>
            </span>  
            

            <button
              v-if="mode === 'add-from-booking'"
              class="btn btn-outline-success float-right btn-md mt-3"
              :disabled="btnDisabled"
              @click="saveAndSendFromBooking()">
              <i class="fa fa-paper-plane"></i> Crear y Enviar
            </button>

            <button
              v-if="(mode === 'view') && ( idRol === 1 || idRol === 2 || idRol === 5 || idRol === 9999) && (type == 1)"
              class="btn btn-outline-success float-right btn-md mt-3"
              :disabled="btnDisabled"
              @click="enviarAInttra()">
              <i class="fa fa-paper-plane"></i> Enviar a Inttra
            </button>

            <button
              v-if="mode === 'use-template'"
              class="btn btn-outline-success float-right btn-md mt-3"
              @click="saveAndSendTemplate()"
              :disabled="btnUseTemplate">
              <i class="fa fa-paper-plane"></i> Crear y Enviar
            </button>

          </div>
        </div>
      </div>
    </div>
    <reject-reason-shipping-modal
      v-if="idRol === 1 || idRol === 2 || idRol === 5 || idRol === 9999"
      :id="parseInt(id)">
    </reject-reason-shipping-modal>
  </div>
</template>

<script>
// Vue
import Vue from "vue";

import VueToastify from "vue-toastify";

Vue.use(VueToastify);

import UiTextbox from "keen-ui/lib/UiTextbox";
import UiRadioGroup from "keen-ui/lib/UiRadioGroup";


import { mapActions, mapState } from "vuex";
import FieldsetComponent from "../../../components/common/FieldsetComponent";
import {
  editarShippingInstruction,
  getListasGenerales,
  getShippingInstructionsConfirmadas,
  getShippingInstructionsEnviadas,
  getShippingInstructionsPorEnviar,
  getShippingInstructionsRechazadas,
  listarBookingItineraryByBookingNumber,
  listarNavesPorNaviera,
  listarViajesPorNaviera,
  saveShippingInstructions,
  verShippingInstruction,
  getShippingInstructionsTemplates,
  getTotalCountSteps,
  sendInttra,
  downloadPdf,
  listarBookingItineraryByBookingItineraryId,
  aprobarShippingInstruction,
  getShippingInstructionsPorRealizar,
  getShippingInstructionsPorEnviarFiltros,
  getShippingInstructionsEnviadasFiltro,
  getShippingInstructionsConfirmadasFiltro,
  getShippingInstructionsRechazadasFiltro,
  getShippingInstructionsTemplatesFiltro,
  getShippingInstructionsPorRealizarFiltros, getTotalCountStepsCharter
}
  from "@/constants/shippinginstructions";

import Button from "../../common/Button";
import Loading from "../../common/loading";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import RejectReasonShippingModal from "@/components/modals/shippinginstructions/RejectReasonShippingModal.vue";
import { getCharterSIPorEnviar, getCharterSiTemplates } from "../../../constants/charter";

const weightMask = createNumberMask({
  prefix: "",
  suffix: "",
  allowDecimal: true,
  requireDecimal: false,
  includeThousandsSeparator: false,
  decimalSymbol: ".",
  decimalLimit: 3,
  integerLimit: 6
});

export default {
  props: {
    id: { Type: String, default: "" },
    idBookingItinerary: { Type: String, default: "" },
    mode: { Type: String, default: "" },
    closeModal: {
      type: Function, default: () => {
      }
    },
    rechargeList: {
      type: Function, default: () => {
      }
    },
    showButtonRecharge: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      weightMask,
      estadoBotonEliminarContainer: false,
      showAllFreightCharges: true,
      chargeOption: "1",
      vessels: [],
      voyages: [],
      blTypeValue: "original",
      totalShipmentWeight: 21000,
      totalNumbeOfPackages: 1,
      totalNumberOfContainers: 1,
      btnDisabled: true,
      disabledNavieraId: false,
      disabledVessel: false,
      disabledVoyage: false,
      disabledOrigin: false,
      disabledLoad: false,
      disabledDestination: false,
      disabledDischarge: false,
      disabledMoveType: false,
      btnUseTemplate: false,
      userRol: "",
      idRol: null,
      consignees: [],
      notifies: [],
      notifiesAddress: [],
      consigneesAddress: [],
      notify: "",
      consignee: "",
      textBtnDownloadPdf: "Descargar PDF",
      form: {
        // Detalles Generales
        booking_number: "",

        shipper_name: "",
        forwarder: "",
        freight_payer_name: "",
        //
        shipper_address: "",
        forwarder_address: "",
        freight_payer_address: "",
        //
        consignee_name: "",
        notify_name: "",
        naviera_id: "",
        //
        consignee_address: "",
        notify_address: "",
        bill_of_release_office: {},
        // Transport
        vessel: {},
        voyage: {},
        //
        port_origin_id: {},
        port_load_id: [],
        move_type: [],
        //
        port_destination_id: [],
        port_discharge_id: [],
        container_shipping_instructions: [
          {
            container_number: "",
            container_id: "",
            container_net_weight: "",
            container_net_weight_type: {
              label: "Kgm",
              value: "1"
            },
            container_tare_weight: "",
            container_tare_weight_type: {
              label: "Kgm",
              value: "1"
            },
            container_gross_volume: "",
            container_gross_type: "CBM",
            container_temperature: "",
            container_temperature_type: "°C",
            container_ventilation: "",
            container_ventilation_type: "CBM",
            carrier_seal_number: "",
            shipper_seal_number: "",
            terminal_operator_seal_number: "",
            veterinary_seal_number: "",
            customs_seal_number: "",
            shipping_instructions_container_cargos: [
              {
                package_count: "",
                package_type_id: [],
                hs_code: "",
                description: "",
                gross_weight: "",
                gross_weight_type: {
                  label: "Kgm",
                  value: "1"
                },
                gross_volume: "",
                marks_and_numbers: "",
                pallet_id : {}
              }
            ]
          }
        ],

        freight_charges: [
          {
            charge_type_id: {},
            freight_term: {},
            payer: {},
            payment_location_id: {},
            options:[],
          }
        ],
        // B/L Print Instructions (Provided to the Carrier, not printed on Bill of Landings)
        freighted_copies: "",
        non_negotiable_freighted_copies: "",
        unfreighted_copies: "",
        non_negotiable_unfreighted_copies: "",
        bl_comments: "",
        house_bill_number: "",
        bl_type: "original",
        template_name: "",
        dus : "",
        recharges : [],
      },
      type : 1,
      palletsList : [],
      recharges : [],
      tariffBase: []
    };
  },
  computed: {
    ...mapState([
      "contenedores",
      "puertos",
      "payers",
      "navieras",
      "usuarioActual"
    ]),
    ...mapState("shippinginstructions", [
      "weight_type",
      "listarPackingTypes",
      "chargeTypes",
      "freightTerm",
      "chargesOptions",
      "blType",
      "movesTypes",
      "visibleModalRejectShipping",
      "si_filtered",
      "si_current_filters"
    ])

  },
  components: {
    RejectReasonShippingModal,
    UiTextbox,
    FieldsetComponent,
    Button,
    Loading,
    UiRadioGroup
  },

  methods: {
    openModal(ref) {
      this.$refs[ref].open();
    },
    ...mapActions([
      "ActionSetPuertos",
      "ActionSetPayers",
      "ActionSetNavieras",
      "ActionSetContenedores",
      "ActionSetLoadingTable"
    ]),
    ...mapActions("shippinginstructions", [
      "actionSetListarPackingTypes",
      "actionSetChargeTypes",
      "actionSetDataDataShippingInstructionPorEnviar",
      "actionSetDataDataShippingInstructionPorRealizar",
      "actionSetDataDataShippingInstructionEnviadas",
      "actionSetDataDataShippingInstructionConfirmadas",
      "actionSetDataDataShippingInstructionRechazadas",
      "actionSetDataDataShippingInstructionTemplates",
      "actionSetTotalCountSteps",
      "actionSetTotalCountStepsCharter",
      "actionSetVisibleModalRejectShipping",
      "actionSetSIFiltered",
      "actionSetVisibleModalInformacionShipping",
      "actionSetDataDataShippingInstructionPorAprobarFiltrada"
    ]),
    ...mapActions("charter", [
      "actionSetDataTablePorEnviar",
      "actionSetDataTableCharterSI",
      "actionSetDataTableCharterSITemplates",
      "actionSetDataFilterNaviera"
    ]),
    asingneConsignee() {

      this.form.consignee_name = this.consignee;
      this.consigneesAddress.forEach(ca => ca.name === this.consignee && (this.form.consignee_address = ca.address));
      this.cutConsigneeAndNotify();

    },
    asingneNotify() {
      this.form.notify_name = this.notify;
      this.notifiesAddress.forEach(na => na.name === this.notify && (this.form.notify_address = na.address));
      this.cutConsigneeAndNotify();
    },
    resetForm() {

      this.form = {
        // Detalles Generales
        booking_number: "",

        shipper_name: "",
        forwarder: "",
        freight_payer_name: "",
        //
        shipper_address: "",
        forwarder_address: "",
        freight_payer_address: "",
        //
        consignee_name: "",
        notify_name: "",
        naviera_id: "",
        //
        consignee_address: "",
        notify_address: "",
        bill_of_release_office: {},
        // Transport
        vessel: {},
        voyage: {},
        //
        port_origin_id: {},
        port_load_id: [],
        move_type: [],
        //
        port_destination_id: [],
        port_discharge_id: [],
        container_shipping_instructions: [
          {
            container_number: "",
            container_id: "",
            container_net_weight: "",
            container_net_weight_type: {
              label: "Kgm",
              value: "1"
            },
            container_tare_weight: "",
            container_tare_weight_type: {
              label: "Kgm",
              value: "1"
            },
            container_gross_volume: "",
            container_gross_type: "Cubic Meters",
            container_temperature: "",
            container_temperature_type: "°C",
            container_ventilation: "",
            container_ventilation_type: "CBM",
            carrier_seal_number: "",
            shipper_seal_number: "",
            terminal_operator_seal_number: "",
            veterinary_seal_number: "",
            customs_seal_number: "",
            shipping_instructions_container_cargos: [
              {
                package_count: "",
                package_type_id: [],
                hs_code: "",
                description: "",
                gross_weight: "",
                gross_weight_type: {
                  label: "Kgm",
                  value: "1"
                },
                gross_volume: "",
                marks_and_numbers: "",
                pallet_id : {}
              }
            ]
          }
        ],

        freight_charges: [
          {
            charge_type_id: {},
            freight_term: {},
            payer: {},
            payment_location_id: {},
            options:[],
          }
        ],
        // B/L Print Instructions (Provided to the Carrier, not printed on Bill of Landings)
        freighted_copies: "",
        non_negotiable_freighted_copies: "",
        unfreighted_copies: "",
        non_negotiable_unfreighted_copies: "",
        bl_comments: "",
        house_bill_number: "",
        bl_type: "original",
        template_name: "" ,
        dus : ""
      };

      if (this.mode === "") {
        this.disabledNavieraId = false;
        this.disabledVessel = false;
        this.disabledVoyage = false;
        this.disabledOrigin = false;
        this.disabledLoad = false;
        this.disabledDestination = false;
        this.disabledDischarge = false;
        this.disabledMoveType = false;

        this.btnDisabled = true;

        this.$refs.booking_number.disabled = false;
      }

      this.notifies = [];
      this.consignees = [];
    },
    eliminarCargo(indexContainer, indexCargo) {
      this.form.container_shipping_instructions[indexContainer].shipping_instructions_container_cargos = this.form.container_shipping_instructions[indexContainer]
        .shipping_instructions_container_cargos.filter((val, i) => i != indexCargo);
      this.calcularTotalShipmentWeight();
      this.calcularTotalNumbeOfPackages();
    },
    anadirCargo(index) {
      this.form.container_shipping_instructions[index]
        .shipping_instructions_container_cargos.push(
        {
          package_count: "",
          package_type_id: [],
          hs_code: "",
          description: "",
          gross_weight: "",
          gross_weight_type: {
            label: "Kgm",
            value: "1"
          },
          gross_volume: "",
          marks_and_numbers: "",
          pallet_id : {}
        }
      );

    },
    
    validateContainer(index) {
      
      if (!this.form.container_shipping_instructions[index].container_id.with_ac && 
          !this.form.container_shipping_instructions[index].container_id.with_frozen) {
            
            this.form.container_shipping_instructions[index].container_temperature = "";
            this.form.container_shipping_instructions[index].container_ventilation = "";

            this.$refs['containerParameters'+index] && (this.$refs['containerParameters'+index][0].style.display = "none");
          }
          else{

            this.$refs['containerParameters'+index] && (this.$refs['containerParameters'+index][0].style.display = "flex");

          }
      },

    setPallet( shippingInstruction ){

      this.form.port_destination_id = {
        id: shippingInstruction.port_discharge_id,
        name: shippingInstruction.port_discharge_name
      };

      this.form.id_client = shippingInstruction.client_id;

      this.form.forwarder = shippingInstruction.forwarder;

      this.form.booking_itinerary_id = null ;

      this.disabledNavieraId = true;
      this.disabledVessel = true;
      this.disabledVoyage = true;
      this.disabledOrigin = true;
      this.disabledLoad = true;
      this.disabledDestination = true;
      this.disabledDischarge = true;
      this.disabledMoveType = true;

      this.btnDisabled = false;

      this.form.container_shipping_instructions[0].shipping_instructions_container_cargos[0].hs_code = shippingInstruction.hs_code;

      this.form.container_shipping_instructions[0].container_number = "XXXX0000000";
      this.form.container_shipping_instructions[0].container_id = {
        id : 4 ,
        code : "40'RF"
      };

      this.form.container_shipping_instructions[0].shipping_instructions_container_cargos[0].package_type_id = {
        id : 316,
        name : "Pallet"
      };

      this.notifies = shippingInstruction.client_notifies.map(n => n.name);
      this.consignees = shippingInstruction.client_consignees.map(c => c.name);

      this.consigneesAddress = shippingInstruction.client_consignees;
      this.notifiesAddress = shippingInstruction.client_notifies;

      this.tariffBase = [];
      this.recharges  = [];

    },
    setContainer( shippingInstruction ) {

      this.form.port_destination_id = {
        id: shippingInstruction.port_destination_id,
        name: shippingInstruction.port_destination_name
      };

      if (this.mode !== "use-template") {

        this.form.container_shipping_instructions[0].container_id = {
          id: parseInt(shippingInstruction.container_id),
          code: shippingInstruction.container_code
        };

        this.form.container_shipping_instructions[0].shipping_instructions_container_cargos[0].hs_code = shippingInstruction.hs_code;

      }

      this.form.container_shipping_instructions[0].container_temperature = shippingInstruction.container_temperature;

      this.form.container_shipping_instructions[0].container_ventilation = shippingInstruction.container_ventilation;
      
      this.form.id_client = shippingInstruction.id_client;

      this.form.forwarder = shippingInstruction.forwarder;

      this.form.booking_itinerary_id = null ;


      this.btnDisabled = false;

      this.notifies = shippingInstruction.client_notifies.map(n => n.name);
      this.consignees = shippingInstruction.client_consignees.map(c => c.name);

      this.consigneesAddress = shippingInstruction.client_consignees;
      this.notifiesAddress = shippingInstruction.client_notifies;

    },
    disabledField(){
      this.disabledNavieraId = true;
      this.disabledVessel = true;
      this.disabledVoyage = true;
      this.disabledOrigin = true;
      this.disabledLoad = true;
      this.disabledDestination = true;
      this.disabledDischarge = true;
      this.disabledMoveType = true;
    },
    async getBookingItineraries() {
      const bookingNumber = this.form.booking_number.toString().trim();
      this.$refs.booking_number.disabled = true;

      this.form.dus = "";

      this.$vToastify.loader("Buscando Carrier Booking Number...");

      try {

        const { status, data } = await listarBookingItineraryByBookingNumber(bookingNumber);

        if (!status) {
          this.$vToastify.stopLoader();
          this.$refs.booking_number.disabled = false;
          return this.$vToastify.error(
            "Carrier Booking Number no encontrado.",
            "¡Error!"
          );
        }

        this.form.naviera_id = {
          id: data.naviera_id,
          name: data.naviera_name
        };

        this.form.shipper_name = data.shipper_name;
        this.form.shipper_address = data.address;

        this.type = data.type ;

        this.form.vessel = {
          id: data.vessel ?? data.ship_name,
          name: data.vessel ?? data.ship_name
        };

        this.form.voyage = {
          id: data.voyage ?? data.trip ,
          name: data.voyage ?? data.trip
        };

        this.form.port_origin_id = {
          id: data.port_origin_id ?? data.pol_id ,
          name: data.port_origin_name ?? data.pol_name
        };

        this.form.port_load_id = {
          id: data.port_load_id ?? data.pol_id,
          name: data.port_load_name ?? data.pol_name
        };

        this.form.port_discharge_id = {
          id: data.discharge_ports_id ?? data.port_discharge_id,
          name: data.discharge_ports_name ?? data.port_discharge_name
        };


        this.form.move_type = {
          id: data.move_type ?? data.move_type_id,
          name: data.move_type_name ?? data.move_type_name
        };

        if (data.type === 3) {

          await this.setContainer(data);

        }

        if (data.type === 2) {

          await this.setPallet(data);

        }

        if(data.type === 1) {

          this.form.port_destination_id = {
            id: data.port_destination_id,
            name: data.port_destination_name
          };


          this.form.container_shipping_instructions[0].container_id = {
            id: parseInt(data.container_id),
            code: data.container_name
          };

          this.form.container_shipping_instructions[0].container_temperature = data.container_temperature;

          this.form.container_shipping_instructions[0].container_ventilation = data.container_ventilation;

          this.form.container_shipping_instructions[0].shipping_instructions_container_cargos[0].hs_code = data.hs_code;

          if (this.mode !== "use-template") {
            this.form.container_shipping_instructions[0].shipping_instructions_container_cargos[0].description = data.description;
          }

          this.form.id_client = data.id_client;

          this.form.forwarder = data.forwarder;

          this.form.booking_itinerary_id = data.booking_itinerary_id;

          this.disabledNavieraId = true;
          this.disabledVessel = true;
          this.disabledVoyage = true;
          this.disabledOrigin = true;
          this.disabledLoad = true;
          this.disabledDestination = true;
          this.disabledDischarge = true;
          this.disabledMoveType = true;

          this.btnDisabled = false;

          this.notifies = data.client_notifies.map(n => n.name);
          this.consignees = data.client_consignees.map(c => c.name);

          this.consigneesAddress = data.client_consignees;
          this.notifiesAddress = data.client_notifies;

          this.recharges = [];

          this.tariffBase = [];

          if (data.recharges && data.tariffBase) {

            this.recharges = data.recharges;

            this.tariffBase = data.tariffBase;

          }
        }

        this.disabledField();


        if (data) {

          this.$vToastify.stopLoader();

          this.$refs.booking_number.disabled = false;

          return this.$vToastify.success(
            "Carrier Booking Number encontrado.",
            "¡Listo!"
          );
        }


      } catch (error) {

        this.$vToastify.stopLoader();

        this.$refs.booking_number.disabled = false;

        return this.$vToastify.error(
          "Puede que se haya producido un error al obtener información del booking, por favor, revise que los datos sean válidos.",
          "¡Error!"
        );

      }
    },
    async getBookingItinerariesItinerariesById() {

      this.loading = true;
      const { status, data } = await listarBookingItineraryByBookingItineraryId(this.idBookingItinerary);
      if (!status) {
        return this.$vToastify.error(
          "Booking Itinerary no encotrado.",
          "¡Error!"
        );
      }

      this.recharges = data.recharges.length > 0  ?  data.recharges : [] ;
      this.tariffBase = data.tariffBase.length > 0  ?  data.tariffBase : [] ;

      this.form.naviera_id = {
        id: data.naviera_id,
        name: data.naviera_name
      };

      this.form.shipper_name = data.shipper_name;
      this.form.shipper_address = data.address;
      this.form.booking_number = data.booking_number;

      this.form.port_origin_id = {
        id: data.port_origin_id,
        name: data.port_origin_name
      };

      this.form.port_load_id = {
        id: data.port_load_id,
        name: data.port_load_name
      };

      this.form.port_destination_id = {
        id: data.port_destination_id,
        name: data.port_destination_name
      };

      this.form.port_discharge_id = {
        id: data.discharge_ports_id,
        name: data.discharge_ports_name
      };

      this.form.move_type = {
        id: data.move_type,
        name: data.move_type_name
      };

      this.form.vessel = {
        id: data.vessel,
        name: data.vessel
      };

      this.form.voyage = {
        id: data.voyage,
        name: data.voyage
      };

      this.form.container_shipping_instructions[0].container_id = {
        id: parseInt(data.container_id),
        code: data.container_name
      };

      this.form.container_shipping_instructions[0].container_temperature = data.container_temperature;

      this.form.container_shipping_instructions[0].container_ventilation = data.container_ventilation;

      this.form.container_shipping_instructions[0].shipping_instructions_container_cargos[0].hs_code = data.hs_code;
      this.form.container_shipping_instructions[0].shipping_instructions_container_cargos[0].description = data.description ?? data.charter_product_name ;

      this.form.id_client = data.id_client;
      this.form.booking_itinerary_id = data.booking_itinerary_id;

      this.form.forwarder = data.forwarder;

      this.disabledNavieraId = true;
      this.disabledVessel = true;
      this.disabledVoyage = true;
      this.disabledOrigin = true;
      this.disabledLoad = true;
      this.disabledDestination = true;
      this.disabledDischarge = true;
      this.disabledMoveType = true;

      this.btnDisabled = false;

      this.loading = false;

      this.notifies = data.client_notifies.map(n => n.name);
      this.consignees = data.client_consignees.map(c => c.name);

      this.consigneesAddress = data.client_consignees;
      this.notifiesAddress = data.client_notifies;

      this.applyFormat();
    },
    eliminarContainer(index) {
      this.form.container_shipping_instructions =
        this.form.container_shipping_instructions.filter((val, i) => i != index);

      this.calcularNumberOfContainers();
      this.calcularTotalShipmentWeight();
      this.calcularTotalNumbeOfPackages();
    },
    duplicarContainer(index) {

      if (this.form.container_shipping_instructions[index]) {

        let newContainer = JSON.parse(JSON.stringify(this.form.container_shipping_instructions[index]));
        newContainer.id = null;
        this.form.container_shipping_instructions.push(newContainer);
      }

      this.calcularTotalShipmentWeight();
      this.calcularNumberOfContainers();
      this.calcularTotalNumbeOfPackages();

    },
    validarFormatoContainer(index) {

      const containerNumber = this.form.container_shipping_instructions[index].container_number;

      if (!containerNumber.match("^([A-Z]|[a-z]){4}([0-9]{7})?$")) {

        this.$vToastify.error(
          "Container number inválido, debe tener formato: AAAA0000000",
          "¡Error!"
        );

      }

    },
    formatoAddress({ event, field, length, lines }, validNaviera = false) {

      const text = this.formatoShippingaddressByParametros(event.target.value, length, lines, validNaviera, field);
      this.form[field] = text;
    },
    formatoShippingaddressByParametros(text, largo, lineas = 20, validNaviera = false, field) {

      text = text ?? "" ;

      if (validNaviera) {
        text = this.form.naviera_id.id == 39 ? text.slice(0, 280) : text.slice(0, 160);
      }

      if (text[text.length - 1] == "\n") text = text.slice(0, -1);

      let lines = (text.split("\n")).slice(0, 4);
      let string = "";

      if (field == "shipper_address") {
        largo = this.form.naviera_id.id == 39 ? 70 : 35;
        lineas = 4;
      }

      if (field == "consignee_address") {
        largo = this.form.naviera_id.id == 39 ? 70 : 35;
        lineas = 4;
      }

      if (field == "notify_address" || field == "forwarder_address" || field == "freight_payer_address") {
        largo = this.form.naviera_id.id == 39 ? 70 : 35;
        lineas = 4;
      }

      for (let i = 0; i < lines.length; i++) {
        let line = lines[i].replace(/(\r\n|\n|\r)/gm, "");

        if (i === (lines.length - 1)) {
          line = this.agregaSaltoLineaByParametro(line, largo);
          string += line;
        } else {
          line = this.agregaSaltoLineaByParametro(line, largo);
          string += line + "\n";
        }
        if (parseInt(lineas) == (i + 1)) break;
      }
      if (string[string.length - 1] == "\n") string = string.slice(0, -1);
      return string;
    },
    cutConsigneeAndNotify(){

      const lengthText = this.form.naviera_id.id == 39 ? 70 : 35 ;

      this.form.notify_name    = this.form.notify_name.slice( 0, lengthText ) ;
      this.form.consignee_name = this.form.consignee_name.slice( 0, lengthText ) ;
      
    },
    agregaSaltoLineaByParametro(text, contadorDeCaracteres) {
      let string = "";
      let iteradorDeCaracteres = 0;
      for (let i = 0; i < text.length; i++) {
        let char = text[i];
        iteradorDeCaracteres++;

        if (contadorDeCaracteres === iteradorDeCaracteres) {
          if (text[i + 1] !== undefined) {

            string += char + "\n";
          } else {
            string += char;
          }
          iteradorDeCaracteres = 0;
        } else {
          string += char;
        }

      }
      return string;

    },
    anadirContainer() {
      this.form.container_shipping_instructions.push(
        {
          container_number: "",
          container_id: "",
          container_net_weight: "",
          container_net_weight_type: {
            label: "Kgm",
            value: "1"
          },
          container_tare_weight: "",
          container_tare_weight_type: {
            label: "Kgm",
            value: "1"
          },
          container_gross_volume: "",
          container_gross_type: "Cubic Meters",
          container_temperature: "",
          container_temperature_type: "°C",
          container_ventilation: "",
          container_ventilation_type: "CBM",
          carrier_seal_number: "",
          shipper_seal_number: "",
          terminal_operator_seal_number: "",
          veterinary_seal_number: "",
          customs_seal_number: "",
          shipping_instructions_container_cargos: [
            {
              package_count: "",
              package_type_id: [],
              hs_code: "",
              description: "",
              gross_weight: "",
              gross_weight_type: {
                label: "Kgm",
                value: "1"
              },
              gross_volume: "",
              marks_and_numbers: "",
              pallet_id : {}
            }
          ]
        }
      );

      this.calcularNumberOfContainers();
    },
    changeStateFreight() {
      this.showAllFreightCharges = this.chargeOption === "1";
      if (!this.showAllFreightCharges) {
        this.form.freight_charges = [
          {
            charge_type_id: {
              id: "2",
              name: "Basic Freight"
            },
            freight_term: {},
            payer: {},
            payment_location_id: {},
            options : []
          }
        ];
      } else {

        this.form.freight_charges = [
          {
            charge_type_id: {},
            freight_term: {},
            payer: {},
            payment_location_id: {},
            options : []
          }
        ];
      }
    },
    calcularTotalNumbeOfPackages() {
      let totalValue = 0;
      this.form.container_shipping_instructions.forEach(container => {

        container.shipping_instructions_container_cargos.forEach(
          cargo => totalValue += parseInt(cargo.package_count));
      });

      this.totalNumbeOfPackages = totalValue === 0 ? 1 : totalValue;
    },
    calcularNumberOfContainers() {
      this.totalNumberOfContainers = this.form.container_shipping_instructions.length;
      this.totalRecharge();
    },
    calcularTotalShipmentWeight() {

      let totalValue = 0;

      this.form.container_shipping_instructions.forEach(container => {
        container.shipping_instructions_container_cargos.forEach(cargo => {
          totalValue += parseFloat(cargo.gross_weight);
        });
      });

      const formattedTotal = totalValue.toFixed(3); // Formatear con tres decimales
      const splitTotal = formattedTotal.split(".");

      if (splitTotal[1] === "000") {
        this.totalShipmentWeight = splitTotal[0]; // No hay decimales, retornar solo la parte entera
      } else {
        this.totalShipmentWeight = formattedTotal;
      }

      this.totalRecharge();
    },
    deleteFreightCharges(index) {
      this.form.freight_charges = this.form.freight_charges.filter((val, i) => i != index);
    },
    anadirFreightCharges() {

      if ( 'id' in  this.form.freight_charges[this.form.freight_charges.length-1].charge_type_id ) {
        
        const toNotAdd = this.form.freight_charges.map( fc => +fc.charge_type_id.id );
        let optionsFreightCharges = this.chargeTypes.filter( ct => !toNotAdd.includes( ct.id ) && ct.id != 1);

        this.form.freight_charges.push(
          {
            charge_type_id: {},
            freight_term: {},
            payer: {},
            payment_location_id: {},
            options : optionsFreightCharges
          }
        );
      }else{
        this.$vToastify.warning("Campo Charge Type requerido", "¡Error!");
        
      }
    },
    async rechargeMenuSteptsCount() {

      const { data } = await getTotalCountSteps();

      this.actionSetTotalCountSteps(data);

    },
    async rechargeMenuSteptsCountCharter() {

      const { data } = await getTotalCountStepsCharter();

      this.actionSetTotalCountStepsCharter(data);

    },
    async listarNaves() {

      if (this.form.naviera_id.id !== undefined) {

        const naviera_id = parseInt(this.form.naviera_id.id);

        const { data } = await listarNavesPorNaviera(naviera_id);

        this.vessels = data.map(val => ({ id: val, name: val }));
      }
    },
    async listarViajes() {

      if (this.form.naviera_id.id !== undefined) {
        const form = {
          naviera_id: parseInt(this.form.naviera_id.id),
          vessel: this.form.vessel.id
        };

        const { data } = await listarViajesPorNaviera(form);

        this.voyages = data.map(val => ({ id: val, name: val }));
      }

    },
    async cargarListas() {
      const {
        listaNaviera,
        listarPuertos,
        listarPayers,
        listarContenedores,
        listarPackingTypes,
        chargesTypes,
        infoCountry,
        pallets
      } = await getListasGenerales();

      this.ActionSetNavieras(listaNaviera);
      this.ActionSetPuertos(listarPuertos);
      this.ActionSetPayers(listarPayers);
      this.ActionSetContenedores(listarContenedores);
      this.actionSetListarPackingTypes(listarPackingTypes);
      this.actionSetChargeTypes(chargesTypes);
      this.palletsList = pallets ;
      if (this.mode === "") {
        this.form.forwarder = infoCountry.name;

        this.form.forwarder_address = infoCountry.streetAddress;
      }

    },
    orderDataShipping() {

      return {
        id: this.form.id === undefined ? null : this.form.id,
        booking_number: this.form.booking_number,
        id_client: this.form.id_client === undefined ? "" : this.form.id_client,
        shipper_name: this.form.shipper_name,
        forwarder: this.form.forwarder,
        freight_payer_name: this.form.freight_payer_name,
        shipper_address: this.form.shipper_address,
        forwarder_address: this.form.forwarder_address,
        freight_payer_address: this.form.freight_payer_address,
        naviera_id: this.form.naviera_id.id,
        consignee_address: this.form.consignee_address,
        consignee_name: this.form.consignee_name,
        notify_address: this.form.notify_address,
        notify_name: this.form.notify_name,
        booking_itinerary_id: this.form.booking_itinerary_id === undefined ? "" : this.form.booking_itinerary_id,
        bill_of_release_office: this.form.bill_of_release_office.id,
        vessel: this.form.vessel.id,
        voyage: this.form.voyage.id,
        port_origin_id: this.form.port_origin_id.id,
        port_load_id: this.form.port_load_id.id,
        move_type: this.form.move_type.id,
        port_destination_id: this.form.port_destination_id.id,
        port_discharge_id: this.form.port_discharge_id.id,
        shipping_instructions_container: this.form.container_shipping_instructions.map(c => {
          return {
            id: c.id ?? "",
            container_number: c.container_number,
            container_id: c.container_id.id,
            container_net_weight: c.container_net_weight,
            container_net_weight_type: c.container_net_weight_type.value,
            container_tare_weight: c.container_tare_weight,
            container_tare_weight_type: c.container_tare_weight_type.value,
            container_gross_volume: c.container_gross_volume,
            container_gross_type: c.container_gross_type,
            container_temperature: c.container_temperature,
            container_temperature_type: c.container_temperature_type,
            container_ventilation: c.container_ventilation,
            container_ventilation_type: c.container_ventilation_type,
            carrier_seal_number: c.carrier_seal_number,
            shipper_seal_number: c.shipper_seal_number,
            terminal_operator_seal_number: c.terminal_operator_seal_number,
            veterinary_seal_number: c.veterinary_seal_number,
            customs_seal_number: c.customs_seal_number,
            shipping_instructions_container_cargos: c.shipping_instructions_container_cargos.map(cc => {
              return {
                id: cc.id === undefined ? "" : cc.id,
                container_shipping_instruction_id: c.id === undefined ? "" : c.id,
                package_count: parseInt(cc.package_count),
                package_type_id: cc.package_type_id.id ?? null,
                hs_code: cc.hs_code === undefined ? "" : cc.hs_code,
                description: cc.description,
                gross_weight: cc.gross_weight,
                gross_weight_type: cc.gross_weight_type.value === undefined ? "" : parseInt(cc.gross_weight_type.value),
                gross_volume: cc.gross_volume,
                marks_and_numbers: cc.marks_and_numbers,
                pallet_id : cc.pallet_id.id ?? null
              };
            })

          };
        }),
        freight_charges: this.form.freight_charges.map(fc => ({
          charge_type_id: fc.charge_type_id.id === undefined ? null : fc.charge_type_id.id,
          freight_term: fc.freight_term.id,
          payer: fc.payer.id,
          options:this.chargeTypes,
          payment_location_id: fc.payment_location_id.id === undefined ? null : fc.payment_location_id.id

        })),
        freighted_copies: this.form.freighted_copies,
        non_negotiable_freighted_copies: this.form.non_negotiable_freighted_copies,
        unfreighted_copies: this.form.unfreighted_copies,
        non_negotiable_unfreighted_copies: this.form.non_negotiable_unfreighted_copies,
        bl_comments: this.form.bl_comments,
        house_bill_number: this.form.house_bill_number,
        bl_type: this.form.bl_type,
        template_name: this.form.template_name,
        dus: this.form.dus ? this.form.dus : null ,
        recharges: this.recharges.map(re => ({
          name: re.name,
          currency_id:re.currency_id ?? null,
          unit_id: re.unit_id,
          neta: re.neta,
          public_value: re.public_value,
          total:  re.total,
          // freight_term: re.freight_term.id,
          freight_term: this.usuarioActual.id_country == 8 ? re.freight_term : re.freight_term.id,
          // payer: re.payer.id,
          payer: this.usuarioActual.id_country == 8 ? re.payer : re.payer.id,
          // payment_location: re.payment_location.id,
          payment_location: this.usuarioActual.id_country == 8 ? re.payment_location : re.payment_location.id,
          logistaas_code: re.logistaas_code,
          id_logistaas_code: re.id_logistaas_code,
          container_name: re.container_name,
          is_base: 0,
          total_containers: this.totalNumberOfContainers,
          total_packages: this.totalNumbeOfPackages,
          total_weight: this.totalShipmentWeight
        })),

        tariffBase: this.tariffBase.map(tb => ({
          name: tb.name,
          id_logistaas_code: tb.id_logistaas_code,
          currency_id: tb.currency_id ?? null,
          currency: tb.currency ?? null,
          unit_payment_id: tb.unit_payment_id,
          total: tb.total,
          neta: tb.neta,
          public_value: tb.public_value,
          // freight_term: tb.freight_term.id,
          freight_term: this.usuarioActual.id_country == 8 ? tb.freight_term : tb.freight_term.id,
          payer: this.usuarioActual.id_country == 8 ? tb.payer : tb.payer.id,
          // payer: tb.payer.id,
          container_name: tb.container_name,
          // payment_location: tb.payment_location.id,
          payment_location: this.usuarioActual.id_country == 8 ? tb.payment_location : tb.payment_location.id ,
          is_base: 1
        }))

      };
      


    },
    totalRecharge ( ){
      
      
      this.recharges = this.recharges.map( r => {

        if (r.unit_id == 1) r.total = r.public_value ;
        if (r.unit_id == 2) r.total = (r.public_value * this.totalNumberOfContainers);
        if (r.unit_id == 3) r.total = ( (r.public_value * this.totalShipmentWeight) /1000) ;
        
        return r ;
      }) ;
    },
    async saveAndSend(sendToInttra = true) {
      const valid = this.validForm();
 
      if (!valid) return false;

      const form = {
        shippingInstruction: this.orderDataShipping(),
        sendToInttra
      };

      this.btnDisabled = true;
      this.$vToastify.loader("Agregando Shipping Instruction...");

      try {
        const { data } = await saveShippingInstructions(form);

        this.$vToastify.stopLoader();
        this.btnDisabled = false;


        if (sendToInttra) {

          if (this.userRol === "Cliente" || this.userRol === "Embarcador") {

            //Mensaje Inttra
            !data.data.valid_cutoff && this.$vToastify.warning(
              data.data.response_cutoff,
              "¡Advertencia!"
            );

            //Mensaje Inttra
            data.data.response_inttra
              ? this.$vToastify.success(data.data.message_inttra, "Solicitud realizada")
              : this.$vToastify.warning(data.data.message_inttra, "¡Advertencia!");

          } else {
            data.data.response_inttra
              ? this.$vToastify.success("Shipping instruction enviado correctamente a Logistaas", "Solicitud realizada")
              : this.$vToastify.warning("Error al enviar a logistas ", "¡Error!");
          }

          this.closeModal();

          this.resetForm();

          if (this.type === 1) {

            if (data.data.response_inttra && this.$route.path !== "/shipping-instructions/shipping-instructions-enviados") {

              return this.$router.push({ name: "shippingInstructionsEnviados" });

            } else {

              return await this.rechargeListByPage(sendToInttra);

            }

          } else {

            if (data.data.response_inttra && this.$route.path !== "/charter/si/por-enviar") {

              return this.$router.push({ name: "charter-si-enviadas" });

            } else {

              return await this.rechargeListByPage(sendToInttra);

            }
          }
        }

        this.$vToastify.success(
          "¡Shipping Instruction creada con éxito!",
          "Solicitud realizada"
        );

        this.closeModal();

        this.resetForm();

      } catch (error) {

        this.btnDisabled = false;

        this.$vToastify.stopLoader();

        this.$vToastify.error(
          "Error al agregar Shipping Instruction, intente más tarde.",
          "¡Error!"
        );
      }

    },
    async saveAndSendFromBooking(sendToInttra = true) {

      const valid = this.validForm();

      if (!valid) return false;

      const form = {
        shippingInstruction: this.orderDataShipping(),
        sendToInttra
      };

      this.btnDisabled = true;
      this.$vToastify.loader("Agregando Shipping Instruction...");

      try {
        const { data } = await saveShippingInstructions(form);

        this.$vToastify.stopLoader();
        this.btnDisabled = false;


        if (sendToInttra) {

          if (this.userRol == "Cliente" || this.userRol == "Embarcador") {

            !data.data.valid_cutoff && this.$vToastify.warning(
              data.data.response_cutoff,
              "¡Advertencia!"
            );

            data.data.response_inttra
              ? this.$vToastify.success(data.data.message_inttra, "Solicitud realizada")
              : this.$vToastify.warning(data.data.message_inttra, "¡Advertencia!");

          } else {
            data.data.response_inttra
              ? this.$vToastify.success("Shipping instruction enviado correctamente a Logistaas", "Solicitud realizada")
              : this.$vToastify.warning("Error al enviar a logistas ", "¡Error!");
          }

          this.closeModal();
          this.resetForm();

          if (data.data.response_inttra) {
            return this.$router.push({ name: "shippingInstructionsEnviados" });
          } else {
            return this.$router.push({ name: "shippingInstructionsPorEnviar" });
          }
        }

        this.$vToastify.success(
          "¡Shipping Instruction creada con éxito!",
          "Solicitud realizada"
        );

        this.closeModal();
        this.resetForm();

        return this.$router.push({ name: "shippingInstructionsPorEnviar" });

      } catch (error) {
        this.btnDisabled = false;
        this.$vToastify.stopLoader();

        this.$vToastify.error(
          "Error al agregar Shipping Instruction, intente más tarde.",
          "¡Error!"
        );
      }

    },
    async saveTemplate() {

      const valid = this.validForm(true);

      if (!valid) return false;

      if (this.form.template_name === "" || this.form.template_name.toString().length < 5) {

        this.$refs.template_name.focus();

        return this.$vToastify.error("Template debe ser tener un nombre con 5 caracteres mínimo.", "¡Error!");

      }

      this.btnDisabled = true;

      this.$vToastify.loader("Agregando Template Shipping Instruction...");

      const form = {
        shippingInstruction: this.orderDataShipping(),
        isTemplate: true
      };

      try {

        await saveShippingInstructions(form);

        this.$vToastify.stopLoader();

        this.$vToastify.success("¡Template Shipping Instruction creada con éxito!","Solicitud realizada");

        this.closeModal();

        this.btnDisabled = false;

        //para refrescar sea de charter o de lineas al crear los templates

        if (this.type === 1 && this.$route.path !== "/shipping-instructions/shipping-instructions-templates") {

          await this.$router.push({ name: "shippingInstructionsTemplates" });

        } else if(this.type !== 1 && this.$route.path !== "/charter/si/templates"){

          await this.$router.push({ name: "charter-si-templates" });

        } else {

          await this.rechargeListByPage();

        }

      } catch (error) {

        this.btnDisabled = false;

        this.$vToastify.stopLoader();

        this.$vToastify.error(
          "Error al agregar Template Shipping Instruction, intente más tarde.",
          "¡Error!"
        );

      }
    },
    async saveAndSendTemplate(sendToInttra = true) {

      const valid = this.validForm();

      if (!valid) return false;

      this.btnUseTemplate = true;

      this.$vToastify.loader("Agregando Shipping Instruction...");

      const { data } = await listarBookingItineraryByBookingNumber(this.form.booking_number);

      if (data === null) {

        this.$vToastify.stopLoader();

        this.btnUseTemplate = false;

        return this.$vToastify.error(
          "Booking Number no esta asociado a Booking.",
          "¡Error!"
        );

      }

      const form = {
        shippingInstruction: this.orderDataShipping(),
        sendToInttra
      };

      try {

        let data = {};

        const response = await saveShippingInstructions(form);

        data = response.data;

        this.$vToastify.stopLoader();

        this.$vToastify.success(
          "¡Shipping Instruction creada con éxito!",
          "Solicitud realizada"
        );

        this.closeModal();

        this.btnUseTemplate = false;

        await this.rechargeListByPage(sendToInttra);

        if (this.userRol === "Cliente" || this.userRol === "Embarcador") {

          !data.data.valid_cutoff && this.$vToastify.warning(data.data.response_cutoff, "¡Advertencia!");

          data.data.response_inttra ? this.$vToastify.success(data.data.message_inttra, "Solicitud realizada") : this.$vToastify.warning(data.data.message_inttra, "¡Advertencia!");

        } else {

          data.data.response_inttra ? this.$vToastify.success("Shipping instruction enviado correctamente a Logistaas", "Solicitud realizada") : this.$vToastify.warning("Error al enviar a logistas ", "¡Error!");

        }

        if (this.type === 1) {

          (data.data.response_inttra) ? await this.$router.push({ name: "shippingInstructionsEnviados" }) : await this.$router.push({ name: "shippingInstructionsPorEnviar" });

        } else {

          (data.data.response_inttra) ? await this.$router.push({ name: "charter-si-enviadas" }) : await this.$router.push({ name: "charter-si-por-enviar" });

        }


      } catch (error) {

        this.btnUseTemplate = false;

        this.$vToastify.stopLoader();

        this.$vToastify.error(
          "Error al agregar Shipping Instruction, intente más tarde.",
          "¡Error!"
        );

      }

    },
    selector(selector) {
      return document.querySelector(`#${selector}`);
    },
    async rechargeListByPage(sendToInttra = false) {

      if (this.$route.path === "/shipping-instructions/shipping-instructions-por-enviar") {

        if (sendToInttra) {

          await this.$router.push({ name: "shippingInstructionsEnviados" });

        } else {

          await this.rechargeMenuSteptsCount();

          this.ActionSetLoadingTable(true);

          if (this.si_filtered) {

            const { data_table } = await getShippingInstructionsPorEnviarFiltros(this.si_current_filters);

            this.actionSetDataDataShippingInstructionPorEnviar(data_table);

          } else {

            const { data_table } = await getShippingInstructionsPorEnviar();

            this.actionSetDataDataShippingInstructionPorEnviar(data_table);
          }

          this.ActionSetLoadingTable(false);

        }

      }

      if (this.$route.path === "/shipping-instructions/shipping-instructions-por-realizar") {

        if (sendToInttra) {

          await this.$router.push({ name: "shippingInstructionsEnviados" });

        } else {

          await this.rechargeMenuSteptsCount();

          this.ActionSetLoadingTable(true);

          if (this.si_filtered) {

            const { data_table } = await getShippingInstructionsPorRealizarFiltros(this.si_current_filters);

            this.actionSetDataDataShippingInstructionPorEnviar(data_table);

          } else {

            const { data_table } = await getShippingInstructionsPorRealizar();

            this.actionSetDataDataShippingInstructionPorRealizar(data_table);
          }

          this.ActionSetLoadingTable(false);

        }
      }

      if (this.$route.path === "/shipping-instructions/shipping-instructions-enviados") {

        if (sendToInttra) {

          await this.rechargeMenuSteptsCount();

          this.ActionSetLoadingTable(true);

          if (this.si_filtered) {

            const { data_table } = await getShippingInstructionsEnviadasFiltro(this.si_current_filters);

            this.actionSetDataDataShippingInstructionEnviadas(data_table);

          } else {

            const { data_table } = await getShippingInstructionsEnviadas();

            this.actionSetDataDataShippingInstructionEnviadas(data_table);
          }

          this.ActionSetLoadingTable(false);

        } else {

          await this.$router.push({ name: "shippingInstructionsPorEnviar" });

        }

      }

      if (this.$route.path === "/shipping-instructions/shipping-instructions-confirmados") {


        if (sendToInttra) {

          await this.$router.push({ name: "shippingInstructionsEnviados" });

        } else {

          await this.rechargeMenuSteptsCount();

          this.ActionSetLoadingTable(true);

          if (this.si_filtered) {

            const { data_table } = await getShippingInstructionsConfirmadasFiltro(this.si_current_filters);

            this.actionSetDataDataShippingInstructionConfirmadas(data_table);

          } else {

            const { data_table } = await getShippingInstructionsConfirmadas();

            this.actionSetDataDataShippingInstructionConfirmadas(data_table);
          }

          this.ActionSetLoadingTable(false);
        }
      }

      if (this.$route.path === "/shipping-instructions/shipping-instructions-rechazados") {

        if (sendToInttra) {

          await this.$router.push({ name: "shippingInstructionsEnviados" });

        } else {

          await this.rechargeMenuSteptsCount();

          this.ActionSetLoadingTable(true);

          if (this.si_filtered) {

            const { data_table } = await getShippingInstructionsRechazadasFiltro(this.si_current_filters);

            this.actionSetDataDataShippingInstructionRechazadas(data_table);

          } else {

            const { data_table } = await getShippingInstructionsRechazadas();

            this.actionSetDataDataShippingInstructionRechazadas(data_table);
          }

          this.ActionSetLoadingTable(false);
        }

      }

      if (this.$route.path === "/shipping-instructions/shipping-instructions-templates") {

        if (sendToInttra) {

          await this.$router.push({ name: "shippingInstructionsEnviados" });

        } else {

          await this.rechargeMenuSteptsCount();

          this.ActionSetLoadingTable(true);

          if (this.si_filtered) {

            const { data_table } = await getShippingInstructionsTemplatesFiltro(this.si_current_filters);

            this.actionSetDataDataShippingInstructionTemplates(data_table);

          } else {

            const { data_table } = await getShippingInstructionsTemplates();

            this.actionSetDataDataShippingInstructionTemplates(data_table);
          }

          this.ActionSetLoadingTable(false);
        }

      }

      //para charter

      if (this.$route.path === "/charter/si/por-enviar") {

        if (sendToInttra) {

          await this.$router.push({ name: "charter-si-enviadas" });

        } else {

          await this.rechargeMenuSteptsCountCharter();

          this.ActionSetLoadingTable(true);

          const { data } = await getCharterSIPorEnviar();

          this.actionSetDataTablePorEnviar( data );

          this.ActionSetLoadingTable(false);

        }

      }

      if (this.$route.path === "/charter/si/enviadas") {

        await this.$router.push({ name: "charter-si-por-enviar" });

      }

      if (this.$route.path === "/charter/si/templates") {

        if (sendToInttra) {

          await this.$router.push({ name: "charter-si-enviadas" });

        } else {

          await this.rechargeMenuSteptsCountCharter();

          this.ActionSetLoadingTable(true);

          const { data_table, filtro_naviera } = await getCharterSiTemplates();

          this.actionSetDataTableCharterSITemplates(data_table);

          this.actionSetDataFilterNaviera(filtro_naviera);

          this.ActionSetLoadingTable(false);

        }

      }
    },
    validForm(is_template = false) {
      
      if (this.mode === "") {

        if (this.form.booking_number === "" || !this.form.booking_number) {

          this.$vToastify.error(
            "Campo Carrier Booking Number requerido",
            "¡Error!"
          );

          this.$refs.booking_number.focus();

          return false;
        }
      }

      if ((this.type === 3 || this.type === 2) && this.form.dus === "") {

        this.$vToastify.error("Campo DUS requerido", "¡Error!");

        this.$refs.dus.focus();

        return false;

      }

      //Detalles Generales
      if (this.form.shipper_name === "" || this.form.shipper_name === undefined || !this.form.shipper_name) {

        this.$vToastify.error(
          "Campo Shipper Name requerido",
          "¡Error!"
        );

        this.$refs.shipper_name.focus();

        return false;

      }

      if (this.form.shipper_address === "" || this.form.shipper_address === undefined || !this.form.shipper_address) {

        this.$vToastify.error(
          "Campo Shipper Address requerido",
          "¡Error!"
        );

        this.$refs.shipper_address.focus();

        return false;

      }

      if (this.form.consignee_name === "" || this.form.consignee_name === undefined || !this.form.consignee_name) {

        this.$vToastify.error(
          "Campo Consignee Name requerido",
          "¡Error!"
        );

        this.$refs.consignee_name.focus();

        return false;

      }

      if (this.form.notify_name === "" || this.form.notify_name === undefined || !this.form.notify_name) {

        this.$vToastify.error(
          "Campo Notify Name requerido",
          "¡Error!"
        );

        this.$refs.notify_name.focus();

        return false;

      }

      if (this.form.naviera_id.id === undefined || this.form.naviera_id.id === "" || !this.form.naviera_id.id) {

        this.$vToastify.error(
          "Campo Naviera requerido",
          "¡Error!"
        );

        this.$refs.naviera_id.focus();

        return false;

      }

      if (this.form.consignee_address === undefined || this.form.consignee_address === "" || !this.form.consignee_address) {

        this.$vToastify.error(
          "Campo Consignee Address requerido",
          "¡Error!"
        );


        this.$refs.consignee_address.focus();

        return false;

      }

      if (this.form.notify_address === undefined || this.form.notify_address === "" || !this.form.notify_address) {

        this.$vToastify.error(
          "Campo Notify Address requerido",
          "¡Error!"
        );

        this.$refs.notify_address.focus();

        return false;

      }

      if (this.form.bill_of_release_office.id === undefined || this.form.bill_of_release_office.id === "" || !this.form.bill_of_release_office.id) {

        this.$vToastify.error(
          "Campo B/L Release Office requerido",
          "¡Error!"
        );

        this.$refs.bill_of_release_office.focus();

        return false;

      }

      //*****************************************************************
      //** Si no es el modo usar template, se activan las validaciones **
      //*****************************************************************

      if (this.mode !== "edit-template") {
        //Transport
        if (this.form.vessel.id === undefined || this.form.vessel.id === "" || !this.form.vessel.id) {

          this.$vToastify.error(
            "Campo Vessel requerido",
            "¡Error!"
          );

          this.$refs.vessel.focus();

          return false;

        }

        if (this.form.voyage.id === undefined || this.form.voyage.id === "" || !this.form.voyage.id) {

          this.$vToastify.error(
            "Campo Voyage requerido",
            "¡Error!"
          );

          this.$refs.voyage.focus();

          return false;

        }

        if (this.form.port_origin_id.id === undefined || this.form.port_origin_id.id === "" || !this.form.port_origin_id.id) {

          this.$vToastify.error(
            "Campo Origin requerido",
            "¡Error!"
          );

          this.$refs.port_origin_id.focus();

          return false;

        }

        if (this.form.port_load_id.id === undefined || this.form.port_load_id.id === "" || !this.form.port_load_id.id) {

          this.$vToastify.error(
            "Campo Port of Load requerido",
            "¡Error!"
          );

          this.$refs.port_load_id.focus();

          return false;

        }

        if (this.form.move_type.id === undefined || this.form.move_type.id === "" || !this.form.move_type.id) {

          this.$vToastify.error(
            "Campo Move Type requerido",
            "¡Error!"
          );

          this.$refs.move_type.focus();

          return false;

        }

        if (this.form.port_destination_id.id === undefined || this.form.port_destination_id.id === "" || !this.form.port_destination_id.id) {

          this.$vToastify.error(
            "Campo Destination requerido",
            "¡Error!"
          );

          this.$refs.port_destination_id.focus();

          return false;

        }

        if (this.form.port_discharge_id.id === undefined || this.form.port_discharge_id.id === "" || !this.form.port_discharge_id.id) {

          this.$vToastify.error(
            "Campo Port of Discharge requerido",
            "¡Error!"
          );

          this.$refs.port_discharge_id.focus();

          return false;

        }
      }

      //Particulars
      let validContainer = true;

      if (this.mode !== "edit-template") {

        let indexContainer = 0;

        for (const container of this.form.container_shipping_instructions) {

          if (container.container_number === "" || container.container_number === undefined || !container.container_number) {

            this.$vToastify.error(
              "Campo Container Number requerido",
              "¡Error!"
            );

            validContainer = false;

            this.selector("container_number" + indexContainer).focus();

            break;
          }

          if (container.container_id.code === null || !container.container_id.code || container.container_id.code === "" || container.container_id.code === undefined) {

            this.$vToastify.error(
              "Campo Container Type requerido",
              "¡Error!"
            );

            validContainer = false;

            this.selector("container_id" + indexContainer).focus();

            break;

          }

          if (container.container_id.type == 1) {
            
            if ( !container.container_temperature ) {
                
                this.$vToastify.error(
                "Campo Container Temperature C° requerido",
                "¡Error!"
              );

              validContainer = false;
              
              this.selector("container_temperature" + indexContainer).focus();

              break;
            }

            if ( !container.container_ventilation ) {
              
              this.$vToastify.error(
                "Campo Container Ventilation CBM requerido",
                "¡Error!"
              );

              validContainer = false;
              
              this.selector("container_ventilation_cbm" + indexContainer).focus();

              break;
            }

          }

          let indexCargos = 0;

          let validCargos = true;

          for (const cargo of container.shipping_instructions_container_cargos) {

            if (cargo.package_count === "" || cargo.package_count === undefined || !cargo.package_count) {

              this.$vToastify.error(
                "Campo Package Count requerido",
                "¡Error!"
              );

              validCargos = false;

              validContainer = false;

              this.selector("package_count" + indexContainer + indexCargos).focus();

              break;
            }

            if (this.type === 2) {

              if (!cargo.pallet_id.id) {

                this.$vToastify.error(
                  "Campo Type (*) requerido",
                  "¡Error!"
                );
                validCargos = false;
                validContainer = false;
                this.selector("pallet_id" + indexContainer + indexCargos).focus();
                break;
              }
            } else {

              if (cargo.package_type_id.id === "" || cargo.package_type_id.id === undefined || !cargo.package_type_id.id) {

                this.$vToastify.error(
                  "Campo Type (Outermost) requerido",
                  "¡Error!"
                );
                validCargos = false;
                validContainer = false;
                this.selector("package_type_id" + indexContainer + indexCargos).focus();
                break;
              }
            }


            if (cargo.description === "" || cargo.description === undefined || !cargo.description) {

              this.$vToastify.error(
                "Campo Cargo Description requerido",
                "¡Error!"
              );

              validCargos = false;
              validContainer = false;

              this.selector("description" + indexContainer + indexCargos).focus();

              break;

            }

            if (cargo.gross_weight === "" || cargo.gross_weight === undefined || !cargo.gross_weight) {

              this.$vToastify.error("Campo Cargo Gross Weight (Cargo + Packaging) requerido", "¡Error!");

              validCargos = false;
              validContainer = false;

              this.selector("gross_weight" + indexContainer + indexCargos).focus();

              break;
            }

            indexCargos++;

          }

          if (!validCargos) break;

          indexContainer++;
        }
      }

      if (!validContainer) return false;

      //Freight Charges


      let validFreightCharges = true;
      let indexFreight = 0;

      if (!is_template) {
        // Cuando el booking tiene asociadas tarifas y recargos
        if (this.tariffBase.length > 0 && this.usuarioActual.id_country !== 8) {

          for (const base of this.tariffBase) {

            if (base.freight_term.id === undefined || base.freight_term.id === "" || !base.freight_term.id) {

              validFreightCharges = false;

              this.$vToastify.error("Campo Freight Terms (Tariff Base) requerido", "¡Error!");

              break;

            }

            if (base.payer.id === undefined || base.payer.id === "" || !base.payer.id) {

              validFreightCharges = false;

              this.$vToastify.error("Campo Payer (Tariff Base) requerido", "¡Error!");

              break;

            }

            if (base.payment_location.id === undefined || base.payment_location.id === "" || !base.payment_location.id) {

              validFreightCharges = false;

              this.$vToastify.error("Campo Payment Location (Tariff Base) requerido", "¡Error!");

              break;

            }
          }

          // kiosfelix
          // VALIDACION RECARGOS
          if (this.recharges.length > 0 && this.usuarioActual.id_country !== 8) {

            for (const recharge of this.recharges) {

              if (recharge.freight_term.id === undefined || recharge.freight_term.id === "" || !recharge.freight_term.id) {

                validFreightCharges = false;

                this.$vToastify.error("Campo Freight Terms (Recharges) requerido", "¡Error!");

                break;

              }

              if (recharge.payer.id === undefined || recharge.payer.id === "" || !recharge.payer.id) {

                validFreightCharges = false;

                this.$vToastify.error("Campo Payer (Recharges) requerido", "¡Error!");

                break;

              }

              if (recharge.payment_location.id === undefined || recharge.payment_location.id === "" || !recharge.payment_location.id) {

                validFreightCharges = false;

                this.$vToastify.error("Campo Payment Location (Recharges) requerido", "¡Error!");

                // this.selector("payer" + indexFreight).focus();

                break;

              }
            }

            indexFreight++;
          }

        } else {
          
          if ( this.tariffBase.length  === 0 || this.recharges.length === 0 || this.usuarioActual.id_country === 8) {

            for (const charge of this.form.freight_charges) {

              if (!this.showAllFreightCharges) {

                if (charge.charge_type_id === undefined || charge.charge_type_id === "" || !charge.charge_type_id) {

                  validFreightCharges = false;

                  this.$vToastify.error("Campo Charge Type requerido", "¡Error!");

                  this.selector("charge_type_id" + indexFreight).focus();

                  break;

                }

              }

              if (charge.freight_term.id === undefined || charge.freight_term.id === "" || !charge.freight_term.id) {

                validFreightCharges = false;

                this.$vToastify.error("Campo Freight Term requerido", "¡Error!");

                this.selector("freight_term" + indexFreight).focus();

                break;

              }

              if (charge.payer.id === undefined || charge.payer.id === "" || !charge.payer.id) {

                validFreightCharges = false;

                this.$vToastify.error("Campo Payer requerido", "¡Error!");

                this.selector("payer" + indexFreight).focus();

                break;

              }

              indexFreight++;

            }
          }

        }

        return validFreightCharges;

      } else {

        return validFreightCharges;

      }

    },

    sumarCargoGrossWeightPorContenedor(index){

      let totalGrossWeight = 0;
      
      this.form.container_shipping_instructions[index].shipping_instructions_container_cargos.forEach(cargo => {
        totalGrossWeight += parseFloat(cargo.gross_weight);
      });
      
      this.form.container_shipping_instructions[index].container_net_weight = totalGrossWeight

    },

    sumarCargoGrossVolumePorContenedor(index){
      
      let totalGrossVolume = 0;

      this.form.container_shipping_instructions[index].shipping_instructions_container_cargos.forEach(cargo => {
        totalGrossVolume += parseFloat(cargo.gross_volume);
      });

      this.form.container_shipping_instructions[index].container_gross_volume = totalGrossVolume

    },

    async setDataShippingIntruction(shippingInstruction)  {

      this.notifies = shippingInstruction.client_notifies.map(n => n.name);
      this.consignees = shippingInstruction.client_consignees.map(c => c.name);

      this.consigneesAddress = shippingInstruction.client_consignees;
      this.notifiesAddress = shippingInstruction.client_notifies;

      this.form.booking_number = shippingInstruction.booking_number;
      this.form.dus = shippingInstruction.dus;
      this.form.booking_itinerary_id = shippingInstruction.booking_itinerary_id;
      this.form.id_client = shippingInstruction.id_client;

      this.form.shipper_name = shippingInstruction.shipper_name;
      this.form.forwarder = shippingInstruction.forwarder;
      this.form.freight_payer_name = shippingInstruction.freight_payer_name;
      this.form.shipper_address = shippingInstruction.shipper_address;
      this.form.forwarder_address = shippingInstruction.forwarder_address;

      this.form.freight_payer_address = shippingInstruction.freight_payer_address;

      this.form.consignee_name = shippingInstruction.consignee_name;
      this.form.notify_name = shippingInstruction.notify_name;


      this.notify = shippingInstruction.notify_name;
      this.consignee = shippingInstruction.consignee_name;

      this.form.naviera_id = {
        id: shippingInstruction.naviera_id,
        name: shippingInstruction.naviera_name
      };

      this.form.consignee_address = shippingInstruction.consignee_address;
      this.form.notify_address = shippingInstruction.notify_address;
      this.form.bill_of_release_office = {
        id: shippingInstruction.bill_of_release_office,
        name: shippingInstruction.bill_of_release_office_name
      };

      await this.listarNaves();

      this.form.vessel = {
        id: shippingInstruction.vessel,
        name: shippingInstruction.vessel
      };

      await this.listarViajes();

      this.form.voyage = {
        id: shippingInstruction.voyage,
        name: shippingInstruction.voyage
      };

      this.form.port_origin_id = {
        id: shippingInstruction.port_origin_id,
        name: shippingInstruction.port_origin_name
      };

      this.form.port_load_id = {
        id: shippingInstruction.port_load_id,
        name: shippingInstruction.port_load_name
      };

      this.form.move_type = {
        id: shippingInstruction.move_type.toString(),
        name: shippingInstruction.move_type_name
      };

      this.form.port_destination_id = {
        id: shippingInstruction.port_destination_id,
        name: shippingInstruction.port_destination_name
      };

      this.form.port_discharge_id = {
        id: shippingInstruction.port_discharge_id,
        name: shippingInstruction.port_discharge_name
      };
      
      this.form.container_shipping_instructions = shippingInstruction.shipping_instructions_container.map(si => ({
        id: si.id,
        container_number: si.container_number,
        container_id: {
          id: si.container_id,
          code: si.code
        },
        container_net_weight: si.container_net_weight,
        container_net_weight_type: {
          value: si.container_net_weight_type.toString(),
          label: si.container_net_weight_type_name
        },
        container_tare_weight: si.container_tare_weight,
        container_tare_weight_type: {
          value: si.container_tare_weight_type.toString(),
          label: si.container_tare_weight_type_name
        },
        container_gross_volume: si.container_gross_volume,
        container_gross_type: "Cubic Meters",
        container_temperature: si.container_temperature,
        container_temperature_type: "°C",
        container_ventilation: si.container_ventilation,
        container_ventilation_type: "CBM",
        carrier_seal_number: si.carrier_seal_number,
        shipper_seal_number: si.shipper_seal_number,
        terminal_operator_seal_number: si.terminal_operator_seal_number,
        veterinary_seal_number: si.veterinary_seal_number,
        customs_seal_number: si.customs_seal_number,
        shipping_instructions_container_cargos: si.shipping_instructions_container_cargos.map(c => ({
          id: c.id,
          package_count: c.package_count,
          package_type_id: {
            id: c.package_type_id,
            name: c.package_type_name
          },
          hs_code: c.hs_code,
          description: c.description,
          gross_weight: c.gross_weight,
          gross_weight_type: {
            value: c.gross_weight_type.toString(),
            label: c.gross_weight_type_name
          },
          gross_volume: c.gross_volume !== undefined && c.gross_volume !== null ? c.gross_volume.toString() : "",
          marks_and_numbers: c.marks_and_numbers,
          pallet_id: c.pallet_id ? {
            id: c.pallet_id,
            name: c.pallet_name
          } : {},
        }))
      }));

      this.form.freight_charges = shippingInstruction.freight_charges.map(fc => ({
        charge_type_id: {
          id: fc.charge_type_id,
          name: fc.charge_type_name
        },
        freight_term: {
          id: fc.freight_term,
          name: fc.freight_term_name
        },
        payer: {
          id: fc.payer,
          name: fc.payer_name
        },
        payment_location_id: {
          id: fc.payment_location_id,
          name: fc.payment_location_name
        },
        options : []
      }));


      if (shippingInstruction.freight_charges.length > 0 ) {

        const charge_type_id = shippingInstruction.freight_charges[0].charge_type_id;

        if (charge_type_id === 1 || !charge_type_id) {

          this.showAllFreightCharges = true;

          this.chargeOption = "1";

        } else {

          this.showAllFreightCharges = false;

          this.chargeOption = "2";

        }

      } else {

        this.showAllFreightCharges = true;

        this.chargeOption = "1";

        await this.changeStateFreight();

      }

      this.form.bl_type = shippingInstruction.bl_type;
      this.form.freighted_copies = shippingInstruction.freighted_copies;
      this.form.non_negotiable_freighted_copies = shippingInstruction.non_negotiable_freighted_copies;
      this.form.unfreighted_copies = shippingInstruction.unfreighted_copies;
      this.form.non_negotiable_unfreighted_copies = shippingInstruction.non_negotiable_unfreighted_copies;
      this.form.bl_comments = shippingInstruction.bl_comments;
      this.form.house_bill_number = shippingInstruction.house_bill_number;
      this.form.template_name = shippingInstruction.template_name;
      this.form.id = shippingInstruction.id;

      this.type    = shippingInstruction.id_type;

      this.btnDisabled = false;

      this.calcularTotalShipmentWeight();

      this.calcularNumberOfContainers();

      this.calcularTotalNumbeOfPackages();

    },
    async verShippingInstruction(id) {

      if (id !== "" && id !== undefined) {

        this.loading = true;

        this.resetForm();

        const { data } = await verShippingInstruction(id);

        this.recharges = ( data.recharges.length > 0 ) ? data.recharges : [];

        this.tariffBase = (data.tariffBase.length > 0 ) ? data.tariffBase : [];

        await this.setDataShippingIntruction(data);

        this.cutConsigneeAndNotify();

        this.loading = false;

        this.applyFormat();

      }

      if (this.mode === "view") {

        await this.disabledForm();

      }

    },
    applyFormat() {
      const shipper_address = this.formatoShippingaddressByParametros(this.form.shipper_address, 4, 70, true, "shipper_address");
      this.form.shipper_address = shipper_address;

      const consignee_address = this.formatoShippingaddressByParametros(this.form.consignee_address, 4, 70, true, "consignee_address");
      this.form.consignee_address = consignee_address;

      const notify_address = this.formatoShippingaddressByParametros(this.form.notify_address, 4, 70, true, "notify_address");
      this.form.notify_address = notify_address;

      const forwarder_address = this.formatoShippingaddressByParametros(this.form.forwarder_address, 4, 70, true, "forwarder_address");
      this.form.forwarder_address = forwarder_address;

      const freight_payer_address = this.formatoShippingaddressByParametros(this.form.freight_payer_address, 4, 70, true, "freight_payer_address");
      this.form.freight_payer_address = freight_payer_address;
    },
    async disabledForm() {
      this.disabledNavieraId = true;
      this.disabledVessel = true;
      this.disabledVoyage = true;
      this.disabledOrigin = true;
      this.disabledLoad = true;
      this.disabledMoveType = true;
      this.disabledDestination = true;
      this.disabledDischarge = true;

    },
    async editTemplate() {

      const valid = this.validForm();

      if (!valid) return false;

      const form = {
        shippingInstruction: this.orderDataShipping(),
        isTemplate: true
      };

      this.btnDisabled = true;

      this.$vToastify.loader("Editando Template Shipping Instruction...");

      try {

        const result = await editarShippingInstruction(form);

        if (result.status && result.status === false || result.valid && result.valid === false) {

          this.$vToastify.stopLoader();

          this.$vToastify.error(result.messsage, "¡Error!");

          this.btnDisabled = false;

        } else if (result.status && result.status === true || result.valid && result.valid === true) {

          await this.rechargeListByPage();

          this.$vToastify.stopLoader();

          this.btnDisabled = false;

          this.$vToastify.success("¡Shipping Instruction Template editada con éxito!", "Solicitud realizada");

          this.closeModal();

        } else {

          this.btnDisabled = false;

          this.$vToastify.stopLoader();

          this.$vToastify.error("Por favor, contacte con un administrador.", "Error al procesar la información");

        }

      } catch (error) {

        this.btnDisabled = false;

        this.$vToastify.stopLoader();

        this.$vToastify.error("Error al editar Template Shipping Instruction, intente más tarde.", "¡Error!");
      }
    },
    async editAndSend(sendToInttra = true) {

      const valid = this.validForm();

      if (!valid) return false;

      const form = {
        shippingInstruction: this.orderDataShipping(),
        sendToInttra
      };

      this.btnDisabled = true;

      this.$vToastify.loader("Editando Shipping Instruction...");

      try {

        const { data } = await editarShippingInstruction(form);

        this.$vToastify.stopLoader();

        this.btnDisabled = false;

        this.$vToastify.success(
          "¡Shipping Instruction editada con éxito!",
          "Solicitud realizada"
        );

        if (this.userRol === "Cliente" || this.userRol === "Embarcador") {

          if (sendToInttra) {

            data.response_inttra? this.$vToastify.success(data.message_inttra, "Solicitud realizada") : this.$vToastify.warning(data.message_inttra, "¡Advertencia!");

          }

          this.closeModal();

          if (data.response_inttra && this.$route.path !== "/shipping-instructions/shipping-instructions-enviados") {

            return this.$router.push({ name: "shippingInstructionsEnviados" });

          } else {

            return await this.rechargeListByPage();

          }

        } else {

          if (sendToInttra) {

            data.response_inttra ? this.$vToastify.success("Shipping instruction enviado correctamente a Logistaas", "Solicitud realizada") : this.$vToastify.warning("Error al enviar a logistas ", "¡Error!");

          }
        }

        this.closeModal();

        await this.rechargeListByPage(sendToInttra);

      } catch (error) {

        this.btnDisabled = false;
        this.$vToastify.stopLoader();

        this.$vToastify.error(
          "Error al editar Shipping Instruction, intente más tarde.",
          "¡Error!"
        );
      }

    },
    async enviarAInttra() {

      this.btnDisabled = true;

      this.$vToastify.loader("Enviando Shipping Instruction a Inttra...");

      try {
        const { data } = await sendInttra(this.id);

        this.closeModal();

        this.$vToastify.stopLoader();

        this.btnDisabled = false;

        data.response_inttra ? this.$vToastify.success(data.message_inttra, "Solicitud realizada") : this.$vToastify.warning(data.message_inttra, "¡Advertencia!");

        if (data.response_inttra && this.$route.path !== "/shipping-instructions/shipping-instructions-enviados") {

          return this.$router.push({ name: "shippingInstructionsEnviados" });

        } else {

          return await this.rechargeListByPage(true);

        }

      } catch (error) {

        this.$vToastify.stopLoader();

        this.btnDisabled = false;

        this.$vToastify.error(
          "Error al enviar Shipping Instruction a Inttra, intente más tarde.",
          "¡Error!"
        );

      }
    },
    getPdfName() {
      const username = JSON.parse(localStorage.getItem("user")).username;
      return `SI_${username}_${(new Date().getTime())}.pdf`;
      ;
    },
    async downloadPdf() {

      try {

        this.textBtnDownloadPdf = "Descargando PDF...";
        this.$refs.btnDownloadPdf.disabled = true;

        const response = await downloadPdf(this.id);

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", this.getPdfName());
        document.body.appendChild(link);
        link.click();

        this.textBtnDownloadPdf = "Descargar PDF";
        this.$refs.btnDownloadPdf.disabled = false;

      } catch (error) {
        this.$vToastify.error(
          "Error al descargar el PDF, intente más tarde.",
          "¡Error!"
        );
      }
    },
    approve() {
      try {

        this.$vToastify.prompt({
          body: `¿Desea aprobar esta Shipping Instruction?`,
          answers: {
            "Sí": true,
            "No": false
          }
        }).then(async value => {

          if (value) {

            this.$vToastify.loader("Aprobando Shipping Instruction...");

            let api_response = await aprobarShippingInstruction(this.id);

            if (api_response.status && api_response.status === true) {

              this.$vToastify.success("Se ha aprobó la Shipping Instruction ID: " + this.id, "Éxito");

              this.$vToastify.stopLoader();
              
              this.closeModal("modal");

              return this.$router.push({ name: "shippingInstructionsPorRealizar" });

            } else if (api_response.status && api_response.status === false) {

              this.$vToastify.error("Se ha producido un error al aceptar la Shipping Instruction", "Error");
            }

            this.$vToastify.stopLoader();

          }
        });

      } catch (e) {

        this.$vToastify.error(
          "No se pudo aprobar esta Shipping instruction, por favor inténtelo más tarde.",
          "¡Se produjo un error!"
        );

      }
    },
    async reject() {
      try {

        this.$vToastify.prompt({
          body: `¿Desea rechazar esta Shipping Instruction?`,
          answers: {
            "Sí": true,
            "No": false
          }
        }).then(value => {
          if (value) {
            this.actionSetVisibleModalRejectShipping(true);
          }
        });

      } catch (e) {

        this.$vToastify.error(
          "No se pudo aprobar esta Shipping instruction, por favor inténtelo más tarde.",
          "¡Se produjo un error!"
        );

      }
    }
  },
  watch: {
    id: function(_new) {
      if (_new) this.verShippingInstruction(_new);
    },
    idBookingItinerary: async function(_new) {

      if (_new) await this.getBookingItinerariesItinerariesById();
    }
  },
  mounted() {
    this.cargarListas();
    this.userRol = JSON.parse(localStorage.getItem("user")).rol;
    this.idRol = JSON.parse(localStorage.getItem("user")).id_role;
  }
};
</script>
<style>
#shippingFormComponent .ui-select__display {
  border: none;
  border-bottom-color: none;
  border-bottom-width: unset;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  height: 40px !important;
  padding: 0px 15px;
}

#shippingFormComponent .ui-select__label-text {
  margin-bottom: 0.5rem;
  font-weight: normal !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 0.875rem;
  color: var(--bs-body-color);
  font-weight: bold !important;
}

#shippingFormComponent label {
  font-weight: bold !important;
}

#shippingFormComponent .ui-select.is-disabled .ui-select__display {
  color: rgba(0, 0, 0, 0.55);
  background: #e9ecef;
}

.shipping-instruction__create-and-send {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
</style>
